export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Seedance 1.0 Pro Fast 视频生成器 - 火山引擎AI视频创作平台',
        pageDescription: '体验 Seedance 1.0 Pro Fast 视频生成器，在生成速度与成本效益上实现突破性升级。精准指令解析、无缝多镜头叙事、细节真实性强，助力企业与创作者高效规模化创作视频内容。免费试用火山引擎视频生成模型。',
        pageKeywords: 'Seedance 1.0 Pro Fast, 火山引擎, AI视频生成器, 视频创作, 快速视频生成, 免费AI视频, 微鲤AI',

        // 生成器部分
        generatorTitle: 'Seedance 1.0 Pro Fast 视频生成器',
        generatorDescription: 'Doubao-Seedance-1.0-pro-fast 是火山引擎于 10 月 24 日正式推出的<span class="highlight-bold">视频生成模型</span>，该模型在继承 Seedance 1.0 Pro 核心能力的基础上，实现了<span class="highlight-bold">生成速度与成本效益的突破性升级</span>，助力企业与创作者高效规模化创作视频内容。',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Seedance 1.0 Pro Fast 核心功能',

        // 精准指令解析与执行
        preciseInstructionTitle: '精准指令解析与执行',
        preciseInstructionDescription: '通过深度语义理解，模型可智能推演动作意图、场景逻辑与镜头衔接，实现"所想即所得"的生成效果。',

        // 无缝多镜头叙事能力
        multiShotNarrativeTitle: '无缝多镜头叙事能力',
        multiShotNarrativeDescription: '支持自动规划远近景、特写等镜头，并实现流畅转场，赋予视频影视级质感。',

        // 细节真实性与风格一致性
        detailRealismTitle: '细节真实性与风格一致性',
        detailRealismDescription: '优化人物面部、发丝等细微处表现力，同时确保画质稳定，高度还原参考图风格。',

        // 复杂运动稳定性强化
        complexMotionStabilityTitle: '复杂运动稳定性强化',
        complexMotionStabilityDescription: '基于物理规律模拟运动轨迹，即使在高速或极限场景中也能保持画面稳定流畅。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        step1Title: '选择 Seedance 1.0 Pro Fast 模型',
        step1Description: '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Seedance 1.0 Pro Fast"。',
        step2Title: '输入您的创意内容',
        step2Description: '描述您想要生成的内容，或上传图片进行转换，并选择您喜欢的风格和效果。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的优化视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Seedance 1.0 Pro Fast 模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Seedance 1.0 Pro Fast 模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        seedanceTitle: 'Seedance AI视频生成器',
        hailuo23Title: 'Hailuo 2.3 AI视频生成器',
        sora2Title: 'OpenAI Sora-2 AI视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Seedance 1.0 Pro Fast 适合哪些用户？',
        faq1Answer: '适合需要高频生成视频的创作者、中小企业及自媒体团队，尤其关注成本效益与生成效率的场景。',
        
        faq2Question: '如何体验模型？',
        faq2Answer: '模型已上线火山方舟平台，用户可通过平台提供的体验入口直接试用。',
        
        faq3Question: '与Pro版本相比，Pro Fast是否牺牲了质量？',
        faq3Answer: '否。Pro Fast在提速降价的同时，针对性优化了指令遵循与细节表现力，在多数场景下保持高水准输出。',
        
        faq4Question: '支持生成的视频时长与分辨率？',
        faq4Answer: '支持生成2~12秒之间的任意时长视频，分辨率可灵活选择720P或1080P。',
        
        faq5Question: '是否支持图生视频？效果如何？',
        faq5Answer: '支持。Pro Fast在图生视频方向效果显著，尤其在细节还原与风格一致性上优于同类国际模型。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Seedance 1.0 Pro Fast，高效创作专业级视频内容',
        ctaButton: 'Try Seedance 1.0 Pro Fast on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // Page title and description
        pageTitle: 'Seedance 1.0 Pro Fast Video Generator - Volcano Engine AI Video Creation Platform',
        pageDescription: 'Experience Seedance 1.0 Pro Fast video generator with breakthrough upgrades in generation speed and cost-effectiveness. Precise instruction parsing, seamless multi-shot narrative, strong detail realism, helping enterprises and creators efficiently scale video content creation. Try Volcano Engine video generation model for free.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, AI video generator, video creation, fast video generation, free AI video, 微鲤AI',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Fast Video Generator',
        generatorDescription: 'Seedance 1.0 Pro Fast is a <span class="highlight-bold">video generation model</span> officially launched by Volcano Engine on October 24th. Building upon the core capabilities of Seedance 1.0 Pro, it achieves <span class="highlight-bold">breakthrough upgrades in generation speed and cost-effectiveness</span>, helping enterprises and creators efficiently scale video content creation.',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Seedance 1.0 Pro Fast Core Features',

        // Precise instruction parsing and execution
        preciseInstructionTitle: 'Precise Instruction Parsing and Execution',
        preciseInstructionDescription: 'Through deep semantic understanding, the model can intelligently deduce action intent, scene logic, and shot transitions, achieving "what you think is what you get" generation results.',

        // Seamless multi-shot narrative capability
        multiShotNarrativeTitle: 'Seamless Multi-Shot Narrative Capability',
        multiShotNarrativeDescription: 'Supports automatic planning of wide shots, close-ups, and other camera angles, with smooth transitions, giving videos cinematic quality.',

        // Detail realism and style consistency
        detailRealismTitle: 'Detail Realism and Style Consistency',
        detailRealismDescription: 'Optimizes the expressiveness of subtle details like facial features and hair strands, while ensuring stable image quality and highly accurate reference image style reproduction.',

        // Enhanced complex motion stability
        complexMotionStabilityTitle: 'Enhanced Complex Motion Stability',
        complexMotionStabilityDescription: 'Simulates motion trajectories based on physical laws, maintaining stable and smooth visuals even in high-speed or extreme scenarios.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Seedance 1.0 Pro Fast Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Seedance 1.0 Pro Fast" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Seedance 1.0 Pro Fast Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Seedance 1.0 Pro Fast Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        seedanceTitle: 'Seedance AI Video Generator',
        hailuo23Title: 'Hailuo 2.3 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'Who is Seedance 1.0 Pro Fast suitable for?',
        faq1Answer: 'It is suitable for creators, SMEs, and self-media teams that need to generate videos frequently, especially in scenarios that focus on cost-effectiveness and generation efficiency.',
        
        faq2Question: 'How to experience the model?',
        faq2Answer: 'The model has been launched on the Volcano Ark platform, and users can try it directly through the experience entrance provided by the platform.',
        
        faq3Question: 'Does Pro Fast sacrifice quality compared to the Pro version?',
        faq3Answer: 'No. While increasing speed and reducing costs, Pro Fast has optimized instruction following and detail expressiveness, maintaining high-quality output in most scenarios.',
        
        faq4Question: 'What video duration and resolution are supported?',
        faq4Answer: 'Supports generating videos of any duration between 2-12 seconds, with flexible resolution choices of 720P or 1080P.',
        
        faq5Question: 'Does it support image-to-video? How is the effect?',
        faq5Answer: 'Yes. Pro Fast has significant effects in image-to-video generation, especially superior to similar international models in detail restoration and style consistency.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Seedance 1.0 Pro Fast now and efficiently create professional-grade video content',
        ctaButton: 'Try Seedance 1.0 Pro Fast on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    ja: {
        // ページタイトルと説明
        pageTitle: 'Seedance 1.0 Pro Fast AIビデオジェネレーター - Volcano Engine AI動画作成プラットフォーム',
        pageDescription: 'Seedance 1.0 Pro Fast AIビデオジェネレーターを体験。生成速度とコスト効率の画期的な向上を実現。精密な指示解析、シームレスなマルチショットナラティブ、優れたディテール再現性で、企業やクリエイターの効率的な動画コンテンツ制作を支援します。',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, AI動画生成, 動画作成, 高速動画生成, 無料AI動画, 微鲤AI',

        // ジェネレーターセクション
        generatorTitle: 'Seedance 1.0 Pro Fast AIビデオジェネレーター',
        generatorDescription: 'Doubao-Seedance-1.0-pro-fastは、Volcano Engineが10月24日に正式リリースした<span class="highlight-bold">動画生成モデル</span>です。Seedance 1.0 Proのコア機能を継承しながら、<span class="highlight-bold">生成速度とコスト効率の画期的な向上</span>を実現し、企業やクリエイターの効率的な動画コンテンツ制作を支援します。',
        
        // タブ
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // コア機能セクション
        coreFeaturesTitle: 'Seedance 1.0 Pro Fast コア機能',

        // 精密な指示解析と実行
        preciseInstructionTitle: '精密な指示解析と実行',
        preciseInstructionDescription: '深い意味理解により、モデルはアクションの意図、シーンロジック、ショットの接続を知的に推測し、「思った通りの結果」を生成します。',

        // シームレスなマルチショットナラティブ機能
        multiShotNarrativeTitle: 'シームレスなマルチショットナラティブ機能',
        multiShotNarrativeDescription: '遠景、近景、クローズアップなどのショットを自動計画し、スムーズなトランジションを実現して、動画に映画品質を与えます。',

        // ディテール再現性とスタイル一貫性
        detailRealismTitle: 'ディテール再現性とスタイル一貫性',
        detailRealismDescription: '顔の表情や髪の毛などの微細なディテールの表現力を最適化し、画質の安定性を確保しながら、参照画像のスタイルを高精度に再現します。',

        // 複雑な動きの安定性強化
        complexMotionStabilityTitle: '複雑な動きの安定性強化',
        complexMotionStabilityDescription: '物理法則に基づいて動きの軌跡をシミュレートし、高速または極限シーンでも安定した流れるような映像を維持します。',

        // 使い方セクション
        howToUseTitle: '使い方',
        step1Title: 'Seedance 1.0 Pro Fastモデルを選択',
        step1Description: '<span class="highlight-text">「AI動画生成」</span>ページに移動し、モデルドロップダウンメニューで「Seedance 1.0 Pro Fast」をクリックします。',
        step2Title: 'クリエイティブコンテンツを入力',
        step2Description: '生成したいコンテンツを説明するか、画像をアップロードして変換し、お好みのスタイルとエフェクトを選択します。',
        step3Title: '動画をダウンロード',
        step3Description: '「作成」をクリックして、生成された最適化された動画をダウンロードまたは共有します。',

        // YouTube動画セクション
        youtubeTitle: 'Seedance 1.0 Pro Fastモデルに関するYouTube動画',

        // X投稿セクション
        xPostsTitle: 'Seedance 1.0 Pro Fastモデルに関する人気のX投稿',

        // 他のモデルを探索セクション
        exploreModelsTitle: '他のモデルを探索',
        seedanceTitle: 'Seedance AI動画ジェネレーター',
        hailuo23Title: 'Hailuo 2.3 AI動画ジェネレーター',
        sora2Title: 'OpenAI Sora-2 AI動画ジェネレーター',

        // FAQセクション
        faqTitle: 'よくある質問',
        faq1Question: 'Seedance 1.0 Pro Fastはどのようなユーザーに適していますか？',
        faq1Answer: '頻繁に動画を生成する必要があるクリエイター、中小企業、セルフメディアチームに適しており、特にコスト効率と生成効率を重視するシナリオに最適です。',
        
        faq2Question: 'モデルを体験するにはどうすればよいですか？',
        faq2Answer: 'モデルはVolcano Arkプラットフォームで公開されており、ユーザーはプラットフォームが提供する体験エントランスから直接試用できます。',
        
        faq3Question: 'Pro FastはProバージョンと比較して品質を犠牲にしていますか？',
        faq3Answer: 'いいえ。Pro Fastは速度向上とコスト削減を実現しながら、指示の遵守と詳細表現力を最適化し、ほとんどのシナリオで高品質な出力を維持しています。',
        
        faq4Question: 'サポートされている動画の長さと解像度は？',
        faq4Answer: '2〜12秒の任意の長さの動画を生成でき、解像度は720Pまたは1080Pから柔軟に選択できます。',
        
        faq5Question: '画像から動画への変換はサポートされていますか？効果はどうですか？',
        faq5Answer: 'はい。Pro Fastは画像から動画への変換で顕著な効果を発揮し、特に詳細の復元とスタイルの一貫性において同類の国際モデルより優れています。',

        // CTAセクション
        ctaTitle: '創作を始める準備はできましたか？',
        ctaDescription: 'Seedance 1.0 Pro Fastを今すぐ体験して、プロフェッショナルグレードの動画コンテンツを効率的に作成しましょう',
        ctaButton: 'WeryAIでSeedance 1.0 Pro Fastを試す',
        ctaDisclaimer: 'クレジットカード不要',

        // 動画再生関連
        videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoLoadError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
    },
    ko: {
        // 페이지 제목 및 설명
        pageTitle: 'Seedance 1.0 Pro Fast AI 비디오 생성기 - Volcano Engine AI 비디오 제작 플랫폼',
        pageDescription: 'Seedance 1.0 Pro Fast AI 비디오 생성기를 경험하세요. 생성 속도와 비용 효율성의 획기적인 업그레이드를 실현했습니다. 정밀한 지시 해석, 매끄러운 멀티샷 내러티브, 뛰어난 디테일 사실감으로 기업과 크리에이터의 효율적인 비디오 콘텐츠 제작을 지원합니다.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, AI 비디오 생성기, 비디오 제작, 고속 비디오 생성, 무료 AI 비디오, 微鲤AI',

        // 생성기 섹션
        generatorTitle: 'Seedance 1.0 Pro Fast AI 비디오 생성기',
        generatorDescription: 'Doubao-Seedance-1.0-pro-fast는 Volcano Engine이 10월 24일에 정식 출시한 <span class="highlight-bold">비디오 생성 모델</span>입니다. Seedance 1.0 Pro의 핵심 기능을 계승하면서 <span class="highlight-bold">생성 속도와 비용 효율성의 획기적인 업그레이드</span>를 달성하여 기업과 크리에이터의 효율적인 비디오 콘텐츠 제작을 지원합니다.',
        
        // 탭
        tabImageToVideo: '이미지를 비디오로',
        tabTextToVideo: '텍스트를 비디오로',

        // 핵심 기능 섹션
        coreFeaturesTitle: 'Seedance 1.0 Pro Fast 핵심 기능',

        // 정밀한 지시 해석 및 실행
        preciseInstructionTitle: '정밀한 지시 해석 및 실행',
        preciseInstructionDescription: '깊은 의미 이해를 통해 모델은 동작 의도, 장면 논리, 샷 연결을 지능적으로 추론하여 "생각한 그대로 얻는" 생성 결과를 달성합니다.',

        // 매끄러운 멀티샷 내러티브 기능
        multiShotNarrativeTitle: '매끄러운 멀티샷 내러티브 기능',
        multiShotNarrativeDescription: '원경, 근경, 클로즈업 등의 샷을 자동으로 계획하고 부드러운 전환을 구현하여 비디오에 영화급 품질을 부여합니다.',

        // 디테일 사실감 및 스타일 일관성
        detailRealismTitle: '디테일 사실감 및 스타일 일관성',
        detailRealismDescription: '얼굴 표정과 머리카락 같은 미세한 디테일의 표현력을 최적화하면서 화질 안정성을 보장하고 참조 이미지 스타일을 높은 정확도로 재현합니다.',

        // 복잡한 동작 안정성 강화
        complexMotionStabilityTitle: '복잡한 동작 안정성 강화',
        complexMotionStabilityDescription: '물리 법칙에 기반하여 동작 궤적을 시뮬레이션하여 고속 또는 극한 시나리오에서도 안정적이고 부드러운 영상을 유지합니다.',

        // 사용 방법 섹션
        howToUseTitle: '사용 방법',
        step1Title: 'Seedance 1.0 Pro Fast 모델 선택',
        step1Description: '<span class="highlight-text">"AI 비디오 생성"</span> 페이지로 이동한 다음 모델 드롭다운 메뉴에서 "Seedance 1.0 Pro Fast"를 클릭하세요.',
        step2Title: '창의적인 콘텐츠 입력',
        step2Description: '생성하고 싶은 콘텐츠를 설명하거나 이미지를 업로드하여 변환하고 원하는 스타일과 효과를 선택하세요.',
        step3Title: '비디오 다운로드',
        step3Description: '"생성"을 클릭하여 생성된 최적화된 비디오를 다운로드하거나 공유하세요.',

        // YouTube 비디오 섹션
        youtubeTitle: 'Seedance 1.0 Pro Fast 모델에 관한 YouTube 비디오',

        // X 게시물 섹션
        xPostsTitle: 'Seedance 1.0 Pro Fast 모델에 관한 인기 X 게시물',

        // 다른 모델 탐색 섹션
        exploreModelsTitle: '다른 모델 탐색',
        seedanceTitle: 'Seedance AI 비디오 생성기',
        hailuo23Title: 'Hailuo 2.3 AI 비디오 생성기',
        sora2Title: 'OpenAI Sora-2 AI 비디오 생성기',

        // FAQ 섹션
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Seedance 1.0 Pro Fast는 어떤 사용자에게 적합한가요?',
        faq1Answer: '빈번하게 비디오를 생성해야 하는 크리에이터, 중소기업 및 셀프 미디어 팀에 적합하며, 특히 비용 효율성과 생성 효율성을 중시하는 시나리오에 최적입니다.',
        
        faq2Question: '모델을 경험하려면 어떻게 해야 하나요?',
        faq2Answer: '모델은 Volcano Ark 플랫폼에서 출시되었으며, 사용자는 플랫폼에서 제공하는 체험 입구를 통해 직접 사용해 볼 수 있습니다.',
        
        faq3Question: 'Pro Fast는 Pro 버전에 비해 품질을 희생했나요?',
        faq3Answer: '아니요. Pro Fast는 속도 향상과 비용 절감을 달성하면서 지시 준수와 세부 표현력을 최적화하여 대부분의 시나리오에서 고품질 출력을 유지합니다.',
        
        faq4Question: '지원되는 비디오 길이와 해상도는?',
        faq4Answer: '2~12초 사이의 임의 길이 비디오를 생성할 수 있으며 해상도는 720P 또는 1080P에서 유연하게 선택할 수 있습니다.',
        
        faq5Question: '이미지를 비디오로 변환을 지원하나요? 효과는 어떤가요?',
        faq5Answer: '예. Pro Fast는 이미지를 비디오로 변환에서 뛰어난 효과를 발휘하며, 특히 세부 복원과 스타일 일관성 측면에서 유사한 국제 모델보다 우수합니다.',

        // CTA 섹션
        ctaTitle: '창작을 시작할 준비가 되셨나요?',
        ctaDescription: 'Seedance 1.0 Pro Fast를 지금 경험하고 전문가급 비디오 콘텐츠를 효율적으로 제작하세요',
        ctaButton: 'WeryAI에서 Seedance 1.0 Pro Fast 사용해보기',
        ctaDisclaimer: '신용카드 불필요',

        // 비디오 재생 관련
        videoNotSupported: '브라우저가 비디오 재생을 지원하지 않습니다',
        videoLoadError: '비디오 로드 실패',
        videoReload: '다시 로드',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'Seedance 1.0 Pro Fast 视频生成器 - 火山引擎AI视频创作平台',
        pageDescription: '体验 Seedance 1.0 Pro Fast 视频生成器，在生成速度与成本效益上实现突破性升级。精准指令解析、无缝多镜头叙事、细节真实性强，助力企业与创作者高效规模化创作视频内容。免费试用火山引擎视频生成模型。',
        pageKeywords: 'Seedance 1.0 Pro Fast, 火山引擎, AI视频生成器, 视频创作, 快速视频生成, 免费AI视频, 微鲤AI',

        // 生成器部分
        generatorTitle: 'Seedance 1.0 Pro Fast 视频生成器',
        generatorDescription: 'Doubao-Seedance-1.0-pro-fast 是火山引擎于 10 月 24 日正式推出的<span class="highlight-bold">视频生成模型</span>，该模型在继承 Seedance 1.0 Pro 核心能力的基础上，实现了<span class="highlight-bold">生成速度与成本效益的突破性升级</span>，助力企业与创作者高效规模化创作视频内容。',
        
        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Seedance 1.0 Pro Fast 核心功能',

        // 精准指令解析与执行
        preciseInstructionTitle: '精准指令解析与执行',
        preciseInstructionDescription: '通过深度语义理解，模型可智能推演动作意图、场景逻辑与镜头衔接，实现"所想即所得"的生成效果。',

        // 无缝多镜头叙事能力
        multiShotNarrativeTitle: '无缝多镜头叙事能力',
        multiShotNarrativeDescription: '支持自动规划远近景、特写等镜头，并实现流畅转场，赋予视频影视级质感。',

        // 细节真实性与风格一致性
        detailRealismTitle: '细节真实性与风格一致性',
        detailRealismDescription: '优化人物面部、发丝等细微处表现力，同时确保画质稳定，高度还原参考图风格。',

        // 复杂运动稳定性强化
        complexMotionStabilityTitle: '复杂运动稳定性强化',
        complexMotionStabilityDescription: '基于物理规律模拟运动轨迹，即使在高速或极限场景中也能保持画面稳定流畅。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        step1Title: '选择 Seedance 1.0 Pro Fast 模型',
        step1Description: '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Seedance 1.0 Pro Fast"。',
        step2Title: '输入您的创意内容',
        step2Description: '描述您想要生成的内容，或上传图片进行转换，并选择您喜欢的风格和效果。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的优化视频。',

        // YouTube 视频部分
        youtubeTitle: '关于 Seedance 1.0 Pro Fast 模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Seedance 1.0 Pro Fast 模型的热门 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        seedanceTitle: 'Seedance AI视频生成器',
        hailuo23Title: 'Hailuo 2.3 AI视频生成器',
        sora2Title: 'OpenAI Sora-2 AI视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: 'Seedance 1.0 Pro Fast 适合哪些用户？',
        faq1Answer: '适合需要高频生成视频的创作者、中小企业及自媒体团队，尤其关注成本效益与生成效率的场景。',
        
        faq2Question: '如何体验模型？',
        faq2Answer: '模型已上线火山方舟平台，用户可通过平台提供的体验入口直接试用。',
        
        faq3Question: '与Pro版本相比，Pro Fast是否牺牲了质量？',
        faq3Answer: '否。Pro Fast在提速降价的同时，针对性优化了指令遵循与细节表现力，在多数场景下保持高水准输出。',
        
        faq4Question: '支持生成的视频时长与分辨率？',
        faq4Answer: '支持生成2~12秒之间的任意时长视频，分辨率可灵活选择720P或1080P。',
        
        faq5Question: '是否支持图生视频？效果如何？',
        faq5Answer: '支持。Pro Fast在图生视频方向效果显著，尤其在细节还原与风格一致性上优于同类国际模型。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Seedance 1.0 Pro Fast，高效创作专业级视频内容',
        ctaButton: 'Try Seedance 1.0 Pro Fast on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    pl: {

        // Page title and description
        pageTitle: 'Seedance 1.0 Pro Fast Video Generator - Volcano Engine AI Video Creation Platform',
        pageDescription: 'Experience Seedance 1.0 Pro Fast video generator with breakthrough upgrades in generation speed and cost-effectiveness. Precise instruction parsing, seamless multi-shot narrative, strong detail realism, helping enterprises and creators efficiently scale video content creation. Try Volcano Engine video generation model for free.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, AI video generator, video creation, fast video generation, free AI video, 微鲤AI',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Fast Video Generator',
        generatorDescription: 'Seedance 1.0 Pro Fast is a <span class="highlight-bold">video generation model</span> officially launched by Volcano Engine on October 24th. Building upon the core capabilities of Seedance 1.0 Pro, it achieves <span class="highlight-bold">breakthrough upgrades in generation speed and cost-effectiveness</span>, helping enterprises and creators efficiently scale video content creation.',
        
        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Seedance 1.0 Pro Fast Core Features',

        // Precise instruction parsing and execution
        preciseInstructionTitle: 'Precise Instruction Parsing and Execution',
        preciseInstructionDescription: 'Through deep semantic understanding, the model can intelligently deduce action intent, scene logic, and shot transitions, achieving "what you think is what you get" generation results.',

        // Seamless multi-shot narrative capability
        multiShotNarrativeTitle: 'Seamless Multi-Shot Narrative Capability',
        multiShotNarrativeDescription: 'Supports automatic planning of wide shots, close-ups, and other camera angles, with smooth transitions, giving videos cinematic quality.',

        // Detail realism and style consistency
        detailRealismTitle: 'Detail Realism and Style Consistency',
        detailRealismDescription: 'Optimizes the expressiveness of subtle details like facial features and hair strands, while ensuring stable image quality and highly accurate reference image style reproduction.',

        // Enhanced complex motion stability
        complexMotionStabilityTitle: 'Enhanced Complex Motion Stability',
        complexMotionStabilityDescription: 'Simulates motion trajectories based on physical laws, maintaining stable and smooth visuals even in high-speed or extreme scenarios.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Seedance 1.0 Pro Fast Model',
        step1Description: 'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Seedance 1.0 Pro Fast" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description: 'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description: 'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Seedance 1.0 Pro Fast Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Seedance 1.0 Pro Fast Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        seedanceTitle: 'Seedance AI Video Generator',
        hailuo23Title: 'Hailuo 2.3 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'Who is Seedance 1.0 Pro Fast suitable for?',
        faq1Answer: 'It is suitable for creators, SMEs, and self-media teams that need to generate videos frequently, especially in scenarios that focus on cost-effectiveness and generation efficiency.',
        
        faq2Question: 'How to experience the model?',
        faq2Answer: 'The model has been launched on the Volcano Ark platform, and users can try it directly through the experience entrance provided by the platform.',
        
        faq3Question: 'Does Pro Fast sacrifice quality compared to the Pro version?',
        faq3Answer: 'No. While increasing speed and reducing costs, Pro Fast has optimized instruction following and detail expressiveness, maintaining high-quality output in most scenarios.',
        
        faq4Question: 'What video duration and resolution are supported?',
        faq4Answer: 'Supports generating videos of any duration between 2-12 seconds, with flexible resolution choices of 720P or 1080P.',
        
        faq5Question: 'Does it support image-to-video? How is the effect?',
        faq5Answer: 'Yes. Pro Fast has significant effects in image-to-video generation, especially superior to similar international models in detail restoration and style consistency.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience Seedance 1.0 Pro Fast now and efficiently create professional-grade video content',
        ctaButton: 'Try Seedance 1.0 Pro Fast on 微鲤AI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    es: {
        // Título y descripción de la página
        pageTitle: 'Generador de Video AI Seedance 1.0 Pro Fast - Plataforma de Creación de Video AI Volcano Engine',
        pageDescription: 'Experimenta el generador de video Seedance 1.0 Pro Fast con mejoras revolucionarias en velocidad de generación y rentabilidad. Análisis preciso de instrucciones, narrativa multipanorámica fluida y alto realismo de detalles para ayudar a empresas y creadores a producir contenido de video a escala de manera eficiente.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, generador de video AI, creación de video, generación rápida de video, video AI gratis, 微鲤AI',

        // Sección del generador
        generatorTitle: 'Generador de Video AI Seedance 1.0 Pro Fast',
        generatorDescription: 'Doubao-Seedance-1.0-pro-fast es un <span class="highlight-bold">modelo de generación de video</span> lanzado oficialmente por Volcano Engine el 24 de octubre. Heredando las capacidades centrales de Seedance 1.0 Pro, logra <span class="highlight-bold">mejoras revolucionarias en velocidad de generación y rentabilidad</span>, ayudando a empresas y creadores a producir contenido de video de manera eficiente y escalable.',
        
        // Pestañas
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',

        // Sección de características principales
        coreFeaturesTitle: 'Características Principales de Seedance 1.0 Pro Fast',

        // Análisis y ejecución precisa de instrucciones
        preciseInstructionTitle: 'Análisis y Ejecución Precisa de Instrucciones',
        preciseInstructionDescription: 'A través de una comprensión semántica profunda, el modelo puede deducir inteligentemente la intención de acción, la lógica de escena y las transiciones de toma, logrando resultados de generación "lo que piensas es lo que obtienes".',

        // Capacidad narrativa multipanorámica fluida
        multiShotNarrativeTitle: 'Capacidad Narrativa Multipanorámica Fluida',
        multiShotNarrativeDescription: 'Admite planificación automática de planos generales, primeros planos y otros ángulos de cámara, con transiciones suaves, dando a los videos calidad cinematográfica.',

        // Realismo de detalles y consistencia de estilo
        detailRealismTitle: 'Realismo de Detalles y Consistencia de Estilo',
        detailRealismDescription: 'Optimiza la expresividad de detalles sutiles como rasgos faciales y mechones de cabello, mientras garantiza una calidad de imagen estable y una reproducción altamente precisa del estilo de imagen de referencia.',

        // Estabilidad mejorada de movimientos complejos
        complexMotionStabilityTitle: 'Estabilidad Mejorada de Movimientos Complejos',
        complexMotionStabilityDescription: 'Simula trayectorias de movimiento basadas en leyes físicas, manteniendo imágenes estables y fluidas incluso en escenarios de alta velocidad o extremos.',

        // Sección de cómo usar
        howToUseTitle: 'Cómo Usar',
        step1Title: 'Seleccionar Modelo Seedance 1.0 Pro Fast',
        step1Description: 'Ve a la página <span class="highlight-text">"Generación de Video AI"</span> y luego haz clic en "Seedance 1.0 Pro Fast" en el menú desplegable de modelos.',
        step2Title: 'Ingresa tu Contenido Creativo',
        step2Description: 'Describe lo que quieres generar o carga imágenes para convertir, y elige tus estilos y efectos preferidos.',
        step3Title: 'Descarga tu Video',
        step3Description: 'Haz clic en "Crear" para descargar o compartir el video optimizado generado.',

        // Sección de videos de YouTube
        youtubeTitle: 'Videos de YouTube sobre el Modelo Seedance 1.0 Pro Fast',

        // Sección de publicaciones X
        xPostsTitle: 'Publicaciones Populares de X sobre el Modelo Seedance 1.0 Pro Fast',

        // Sección de explorar otros modelos
        exploreModelsTitle: 'Explorar Otros Modelos',
        seedanceTitle: 'Generador de Video AI Seedance',
        hailuo23Title: 'Generador de Video AI Hailuo 2.3',
        sora2Title: 'Generador de Video AI OpenAI Sora-2',

        // Sección de preguntas frecuentes
        faqTitle: 'Preguntas Frecuentes',
        faq1Question: '¿Para quién es adecuado Seedance 1.0 Pro Fast?',
        faq1Answer: 'Es adecuado para creadores, PYMES y equipos de medios propios que necesitan generar videos con frecuencia, especialmente en escenarios que se centran en la rentabilidad y la eficiencia de generación.',
        
        faq2Question: '¿Cómo experimentar el modelo?',
        faq2Answer: 'El modelo se ha lanzado en la plataforma Volcano Ark y los usuarios pueden probarlo directamente a través de la entrada de experiencia proporcionada por la plataforma.',
        
        faq3Question: '¿Pro Fast sacrifica calidad en comparación con la versión Pro?',
        faq3Answer: 'No. Mientras aumenta la velocidad y reduce los costos, Pro Fast ha optimizado el seguimiento de instrucciones y la expresividad de detalles, manteniendo una salida de alta calidad en la mayoría de los escenarios.',
        
        faq4Question: '¿Qué duración y resolución de video son compatibles?',
        faq4Answer: 'Admite la generación de videos de cualquier duración entre 2 y 12 segundos, con opciones de resolución flexibles de 720P o 1080P.',
        
        faq5Question: '¿Admite imagen a video? ¿Cómo es el efecto?',
        faq5Answer: 'Sí. Pro Fast tiene efectos significativos en la generación de imagen a video, especialmente superior a modelos internacionales similares en restauración de detalles y consistencia de estilo.',

        // Sección CTA
        ctaTitle: '¿Listo para Empezar a Crear?',
        ctaDescription: 'Experimenta Seedance 1.0 Pro Fast ahora y crea contenido de video de nivel profesional de manera eficiente',
        ctaButton: 'Prueba Seedance 1.0 Pro Fast en 微鲤AI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',

        // Relacionado con reproducción de video
        videoNotSupported: 'Tu navegador no admite reproducción de video',
        videoLoadError: 'Error al cargar el video',
        videoReload: 'Recargar',
    },
    fr: {
        // Titre et description de la page
        pageTitle: 'Générateur Vidéo AI Seedance 1.0 Pro Fast - Plateforme de Création Vidéo AI Volcano Engine',
        pageDescription: 'Découvrez le générateur vidéo Seedance 1.0 Pro Fast avec des améliorations révolutionnaires en vitesse de génération et rentabilité. Analyse précise des instructions, narration multi-plans fluide et réalisme des détails élevé pour aider les entreprises et créateurs à produire du contenu vidéo à grande échelle efficacement.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, générateur vidéo AI, création vidéo, génération vidéo rapide, vidéo AI gratuite, 微鲤AI',

        // Section générateur
        generatorTitle: 'Générateur Vidéo AI Seedance 1.0 Pro Fast',
        generatorDescription: 'Doubao-Seedance-1.0-pro-fast est un <span class="highlight-bold">modèle de génération vidéo</span> lancé officiellement par Volcano Engine le 24 octobre. Héritant des capacités centrales de Seedance 1.0 Pro, il réalise des <span class="highlight-bold">améliorations révolutionnaires en vitesse de génération et rentabilité</span>, aidant les entreprises et créateurs à produire du contenu vidéo de manière efficace et évolutive.',
        
        // Onglets
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',

        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales de Seedance 1.0 Pro Fast',

        // Analyse et exécution précises des instructions
        preciseInstructionTitle: 'Analyse et Exécution Précises des Instructions',
        preciseInstructionDescription: 'Grâce à une compréhension sémantique approfondie, le modèle peut déduire intelligemment l\'intention d\'action, la logique de scène et les transitions de plan, obtenant des résultats de génération "ce que vous pensez est ce que vous obtenez".',

        // Capacité narrative multi-plans fluide
        multiShotNarrativeTitle: 'Capacité Narrative Multi-Plans Fluide',
        multiShotNarrativeDescription: 'Prend en charge la planification automatique de plans larges, gros plans et autres angles de caméra, avec des transitions fluides, donnant aux vidéos une qualité cinématographique.',

        // Réalisme des détails et cohérence du style
        detailRealismTitle: 'Réalisme des Détails et Cohérence du Style',
        detailRealismDescription: 'Optimise l\'expressivité de détails subtils comme les traits du visage et les mèches de cheveux, tout en garantissant une qualité d\'image stable et une reproduction très précise du style d\'image de référence.',

        // Stabilité améliorée des mouvements complexes
        complexMotionStabilityTitle: 'Stabilité Améliorée des Mouvements Complexes',
        complexMotionStabilityDescription: 'Simule les trajectoires de mouvement basées sur les lois physiques, maintenant des visuels stables et fluides même dans des scénarios à grande vitesse ou extrêmes.',

        // Section comment utiliser
        howToUseTitle: 'Comment Utiliser',
        step1Title: 'Sélectionner le Modèle Seedance 1.0 Pro Fast',
        step1Description: 'Allez sur la page <span class="highlight-text">"Génération Vidéo AI"</span> puis cliquez sur "Seedance 1.0 Pro Fast" dans le menu déroulant des modèles.',
        step2Title: 'Saisissez votre Contenu Créatif',
        step2Description: 'Décrivez ce que vous voulez générer ou téléchargez des images à convertir, et choisissez vos styles et effets préférés.',
        step3Title: 'Téléchargez votre Vidéo',
        step3Description: 'Cliquez sur "Créer" pour télécharger ou partager la vidéo optimisée générée.',

        // Section vidéos YouTube
        youtubeTitle: 'Vidéos YouTube sur le Modèle Seedance 1.0 Pro Fast',

        // Section publications X
        xPostsTitle: 'Publications X Populaires sur le Modèle Seedance 1.0 Pro Fast',

        // Section explorer d'autres modèles
        exploreModelsTitle: 'Explorer d\'Autres Modèles',
        seedanceTitle: 'Générateur Vidéo AI Seedance',
        hailuo23Title: 'Générateur Vidéo AI Hailuo 2.3',
        sora2Title: 'Générateur Vidéo AI OpenAI Sora-2',

        // Section FAQ
        faqTitle: 'Questions Fréquemment Posées',
        faq1Question: 'Pour qui Seedance 1.0 Pro Fast est-il adapté?',
        faq1Answer: 'Il convient aux créateurs, PME et équipes de médias personnels qui doivent générer fréquemment des vidéos, en particulier dans des scénarios axés sur la rentabilité et l\'efficacité de génération.',
        
        faq2Question: 'Comment expérimenter le modèle?',
        faq2Answer: 'Le modèle a été lancé sur la plateforme Volcano Ark et les utilisateurs peuvent l\'essayer directement via l\'entrée d\'expérience fournie par la plateforme.',
        
        faq3Question: 'Pro Fast sacrifie-t-il la qualité par rapport à la version Pro?',
        faq3Answer: 'Non. Tout en augmentant la vitesse et en réduisant les coûts, Pro Fast a optimisé le suivi des instructions et l\'expressivité des détails, maintenant une sortie de haute qualité dans la plupart des scénarios.',
        
        faq4Question: 'Quelle durée et résolution vidéo sont prises en charge?',
        faq4Answer: 'Prend en charge la génération de vidéos de toute durée entre 2 et 12 secondes, avec des choix de résolution flexibles de 720P ou 1080P.',
        
        faq5Question: 'Prend-il en charge l\'image vers vidéo? Quel est l\'effet?',
        faq5Answer: 'Oui. Pro Fast a des effets significatifs dans la génération d\'image vers vidéo, particulièrement supérieur aux modèles internationaux similaires en restauration de détails et cohérence de style.',

        // Section CTA
        ctaTitle: 'Prêt à Commencer à Créer?',
        ctaDescription: 'Expérimentez Seedance 1.0 Pro Fast maintenant et créez efficacement du contenu vidéo de qualité professionnelle',
        ctaButton: 'Essayez Seedance 1.0 Pro Fast sur 微鲤AI',
        ctaDisclaimer: 'Aucune carte de crédit requise',

        // Lié à la lecture vidéo
        videoNotSupported: 'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
    },
    de: {
        // Seitentitel und Beschreibung
        pageTitle: 'Seedance 1.0 Pro Fast AI-Videogenerator - Volcano Engine AI-Videoerstellungsplattform',
        pageDescription: 'Erleben Sie den Seedance 1.0 Pro Fast Videogenerator mit revolutionären Verbesserungen in Generierungsgeschwindigkeit und Kosteneffizienz. Präzise Anweisungsanalyse, nahtlose Multi-Shot-Erzählung und hoher Detailrealismus zur Unterstützung von Unternehmen und Kreativen bei der effizienten Produktion von Videoinhalten im großen Maßstab.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, AI-Videogenerator, Videoerstellung, schnelle Videogenerierung, kostenloses AI-Video, 微鲤AI',

        // Generator-Bereich
        generatorTitle: 'Seedance 1.0 Pro Fast AI-Videogenerator',
        generatorDescription: 'Doubao-Seedance-1.0-pro-fast ist ein <span class="highlight-bold">Videogenerierungsmodell</span>, das am 24. Oktober offiziell von Volcano Engine veröffentlicht wurde. Es erbt die Kernfähigkeiten von Seedance 1.0 Pro und erreicht <span class="highlight-bold">revolutionäre Verbesserungen in Generierungsgeschwindigkeit und Kosteneffizienz</span>, um Unternehmen und Kreativen zu helfen, Videoinhalte effizient und skalierbar zu produzieren.',
        
        // Registerkarten
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        // Hauptfunktionen-Bereich
        coreFeaturesTitle: 'Hauptfunktionen von Seedance 1.0 Pro Fast',

        // Präzise Anweisungsanalyse und -ausführung
        preciseInstructionTitle: 'Präzise Anweisungsanalyse und -ausführung',
        preciseInstructionDescription: 'Durch tiefes semantisches Verständnis kann das Modell intelligent Handlungsabsichten, Szenenlogik und Aufnahmeübergänge ableiten und Generierungsergebnisse nach dem Motto "Was Sie denken, ist, was Sie bekommen" erzielen.',

        // Nahtlose Multi-Shot-Erzählfähigkeit
        multiShotNarrativeTitle: 'Nahtlose Multi-Shot-Erzählfähigkeit',
        multiShotNarrativeDescription: 'Unterstützt automatische Planung von Weitwinkel-, Nahaufnahmen und anderen Kamerawinkeln mit sanften Übergängen, um Videos kinoreife Qualität zu verleihen.',

        // Detailrealismus und Stilkonsistenz
        detailRealismTitle: 'Detailrealismus und Stilkonsistenz',
        detailRealismDescription: 'Optimiert die Ausdruckskraft subtiler Details wie Gesichtszüge und Haarsträhnen, während eine stabile Bildqualität gewährleistet und der Referenzbildstil mit hoher Genauigkeit reproduziert wird.',

        // Verbesserte Stabilität komplexer Bewegungen
        complexMotionStabilityTitle: 'Verbesserte Stabilität Komplexer Bewegungen',
        complexMotionStabilityDescription: 'Simuliert Bewegungstrajektorien basierend auf physikalischen Gesetzen und hält stabile und flüssige Bilder auch in Hochgeschwindigkeits- oder Extremszenarien aufrecht.',

        // Verwendungsanleitung-Bereich
        howToUseTitle: 'Verwendung',
        step1Title: 'Seedance 1.0 Pro Fast Modell Auswählen',
        step1Description: 'Gehen Sie zur Seite <span class="highlight-text">"AI-Videogenerierung"</span> und klicken Sie dann im Modell-Dropdown-Menü auf "Seedance 1.0 Pro Fast".',
        step2Title: 'Geben Sie Ihren Kreativen Inhalt Ein',
        step2Description: 'Beschreiben Sie, was Sie generieren möchten, oder laden Sie Bilder zum Konvertieren hoch und wählen Sie Ihre bevorzugten Stile und Effekte.',
        step3Title: 'Laden Sie Ihr Video Herunter',
        step3Description: 'Klicken Sie auf "Erstellen", um das generierte optimierte Video herunterzuladen oder zu teilen.',

        // YouTube-Videos-Bereich
        youtubeTitle: 'YouTube-Videos über das Seedance 1.0 Pro Fast Modell',

        // X-Beiträge-Bereich
        xPostsTitle: 'Beliebte X-Beiträge über das Seedance 1.0 Pro Fast Modell',

        // Andere Modelle erkunden-Bereich
        exploreModelsTitle: 'Andere Modelle Erkunden',
        seedanceTitle: 'Seedance AI-Videogenerator',
        hailuo23Title: 'Hailuo 2.3 AI-Videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-Videogenerator',

        // FAQ-Bereich
        faqTitle: 'Häufig Gestellte Fragen',
        faq1Question: 'Für wen ist Seedance 1.0 Pro Fast geeignet?',
        faq1Answer: 'Es eignet sich für Kreative, KMUs und Self-Media-Teams, die häufig Videos generieren müssen, insbesondere in Szenarien, die sich auf Kosteneffizienz und Generierungseffizienz konzentrieren.',
        
        faq2Question: 'Wie kann man das Modell ausprobieren?',
        faq2Answer: 'Das Modell wurde auf der Volcano Ark-Plattform veröffentlicht und Benutzer können es direkt über den von der Plattform bereitgestellten Erfahrungseingang ausprobieren.',
        
        faq3Question: 'Opfert Pro Fast Qualität im Vergleich zur Pro-Version?',
        faq3Answer: 'Nein. Während die Geschwindigkeit erhöht und die Kosten gesenkt werden, hat Pro Fast die Befolgung von Anweisungen und die Detailausdruckskraft optimiert und behält in den meisten Szenarien eine hochwertige Ausgabe bei.',
        
        faq4Question: 'Welche Videolänge und -auflösung werden unterstützt?',
        faq4Answer: 'Unterstützt die Generierung von Videos beliebiger Länge zwischen 2 und 12 Sekunden mit flexiblen Auflösungsoptionen von 720P oder 1080P.',
        
        faq5Question: 'Unterstützt es Bild-zu-Video? Wie ist der Effekt?',
        faq5Answer: 'Ja. Pro Fast hat signifikante Effekte bei der Bild-zu-Video-Generierung, besonders überlegen gegenüber ähnlichen internationalen Modellen in Detailwiederherstellung und Stilkonsistenz.',

        // CTA-Bereich
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription: 'Erleben Sie Seedance 1.0 Pro Fast jetzt und erstellen Sie effizient professionelle Videoinhalte',
        ctaButton: 'Probieren Sie Seedance 1.0 Pro Fast auf 微鲤AI',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',

        // Videowiedergabe-bezogen
        videoNotSupported: 'Ihr Browser unterstützt keine Videowiedergabe',
        videoLoadError: 'Videoladen fehlgeschlagen',
        videoReload: 'Neu laden',
    },
    ru: {
        // Заголовок и описание страницы
        pageTitle: 'AI-генератор видео Seedance 1.0 Pro Fast - Платформа создания AI-видео Volcano Engine',
        pageDescription: 'Испытайте генератор видео Seedance 1.0 Pro Fast с революционными улучшениями в скорости генерации и рентабельности. Точный анализ инструкций, плавное повествование с несколькими кадрами и высокий реализм деталей для помощи предприятиям и создателям в эффективном масштабируемом производстве видеоконтента.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, AI-генератор видео, создание видео, быстрая генерация видео, бесплатное AI-видео, 微鲤AI',

        // Раздел генератора
        generatorTitle: 'AI-генератор видео Seedance 1.0 Pro Fast',
        generatorDescription: 'Doubao-Seedance-1.0-pro-fast - это <span class="highlight-bold">модель генерации видео</span>, официально запущенная Volcano Engine 24 октября. Наследуя основные возможности Seedance 1.0 Pro, она достигает <span class="highlight-bold">революционных улучшений в скорости генерации и рентабельности</span>, помогая предприятиям и создателям эффективно и масштабируемо производить видеоконтент.',
        
        // Вкладки
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',

        // Раздел основных функций
        coreFeaturesTitle: 'Основные функции Seedance 1.0 Pro Fast',

        // Точный анализ и выполнение инструкций
        preciseInstructionTitle: 'Точный анализ и выполнение инструкций',
        preciseInstructionDescription: 'Благодаря глубокому семантическому пониманию модель может интеллектуально определять намерения действий, логику сцены и переходы между кадрами, достигая результатов генерации "что вы думаете, то и получаете".',

        // Плавная способность повествования с несколькими кадрами
        multiShotNarrativeTitle: 'Плавная способность повествования с несколькими кадрами',
        multiShotNarrativeDescription: 'Поддерживает автоматическое планирование широких планов, крупных планов и других ракурсов камеры с плавными переходами, придавая видео кинематографическое качество.',

        // Реализм деталей и согласованность стиля
        detailRealismTitle: 'Реализм деталей и согласованность стиля',
        detailRealismDescription: 'Оптимизирует выразительность тонких деталей, таких как черты лица и пряди волос, обеспечивая при этом стабильное качество изображения и высокоточное воспроизведение стиля эталонного изображения.',

        // Улучшенная стабильность сложных движений
        complexMotionStabilityTitle: 'Улучшенная стабильность сложных движений',
        complexMotionStabilityDescription: 'Моделирует траектории движения на основе физических законов, поддерживая стабильные и плавные изображения даже в сценариях с высокой скоростью или экстремальных условиях.',

        // Раздел как использовать
        howToUseTitle: 'Как использовать',
        step1Title: 'Выбрать модель Seedance 1.0 Pro Fast',
        step1Description: 'Перейдите на страницу <span class="highlight-text">"Генерация AI-видео"</span> и нажмите "Seedance 1.0 Pro Fast" в выпадающем меню моделей.',
        step2Title: 'Введите свой креативный контент',
        step2Description: 'Опишите, что вы хотите сгенерировать, или загрузите изображения для преобразования и выберите предпочитаемые стили и эффекты.',
        step3Title: 'Скачайте свое видео',
        step3Description: 'Нажмите "Создать", чтобы скачать или поделиться сгенерированным оптимизированным видео.',

        // Раздел видео YouTube
        youtubeTitle: 'Видео YouTube о модели Seedance 1.0 Pro Fast',

        // Раздел публикаций X
        xPostsTitle: 'Популярные публикации X о модели Seedance 1.0 Pro Fast',

        // Раздел изучения других моделей
        exploreModelsTitle: 'Изучить другие модели',
        seedanceTitle: 'AI-генератор видео Seedance',
        hailuo23Title: 'AI-генератор видео Hailuo 2.3',
        sora2Title: 'AI-генератор видео OpenAI Sora-2',

        // Раздел FAQ
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: 'Для кого подходит Seedance 1.0 Pro Fast?',
        faq1Answer: 'Он подходит для создателей, МСП и команд собственных медиа, которым необходимо часто генерировать видео, особенно в сценариях, ориентированных на рентабельность и эффективность генерации.',
        
        faq2Question: 'Как попробовать модель?',
        faq2Answer: 'Модель запущена на платформе Volcano Ark, и пользователи могут попробовать ее напрямую через вход для опыта, предоставленный платформой.',
        
        faq3Question: 'Жертвует ли Pro Fast качеством по сравнению с версией Pro?',
        faq3Answer: 'Нет. Увеличивая скорость и снижая затраты, Pro Fast оптимизировал следование инструкциям и выразительность деталей, сохраняя высококачественный вывод в большинстве сценариев.',
        
        faq4Question: 'Какая длительность и разрешение видео поддерживаются?',
        faq4Answer: 'Поддерживает генерацию видео любой длительности от 2 до 12 секунд с гибкими вариантами разрешения 720P или 1080P.',
        
        faq5Question: 'Поддерживает ли изображение в видео? Каков эффект?',
        faq5Answer: 'Да. Pro Fast имеет значительные эффекты в генерации изображения в видео, особенно превосходя аналогичные международные модели в восстановлении деталей и согласованности стиля.',

        // Раздел CTA
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription: 'Испытайте Seedance 1.0 Pro Fast прямо сейчас и эффективно создавайте видеоконтент профессионального уровня',
        ctaButton: 'Попробуйте Seedance 1.0 Pro Fast на 微鲤AI',
        ctaDisclaimer: 'Кредитная карта не требуется',

        // Связано с воспроизведением видео
        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadError: 'Ошибка загрузки видео',
        videoReload: 'Перезагрузить',
    },
    pt: {
        // Título e descrição da página
        pageTitle: 'Gerador de Vídeo AI Seedance 1.0 Pro Fast - Plataforma de Criação de Vídeo AI Volcano Engine',
        pageDescription: 'Experimente o gerador de vídeo Seedance 1.0 Pro Fast com melhorias revolucionárias em velocidade de geração e custo-benefício. Análise precisa de instruções, narrativa multi-planos fluida e alto realismo de detalhes para ajudar empresas e criadores a produzir conteúdo de vídeo em escala de forma eficiente.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, gerador de vídeo AI, criação de vídeo, geração rápida de vídeo, vídeo AI grátis, 微鲤AI',

        // Seção do gerador
        generatorTitle: 'Gerador de Vídeo AI Seedance 1.0 Pro Fast',
        generatorDescription: 'Doubao-Seedance-1.0-pro-fast é um <span class="highlight-bold">modelo de geração de vídeo</span> lançado oficialmente pela Volcano Engine em 24 de outubro. Herdando as capacidades centrais do Seedance 1.0 Pro, alcança <span class="highlight-bold">melhorias revolucionárias em velocidade de geração e custo-benefício</span>, ajudando empresas e criadores a produzir conteúdo de vídeo de forma eficiente e escalável.',
        
        // Abas
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',

        // Seção de recursos principais
        coreFeaturesTitle: 'Recursos Principais do Seedance 1.0 Pro Fast',

        // Análise e execução precisa de instruções
        preciseInstructionTitle: 'Análise e Execução Precisa de Instruções',
        preciseInstructionDescription: 'Através de compreensão semântica profunda, o modelo pode deduzir inteligentemente intenção de ação, lógica de cena e transições de plano, alcançando resultados de geração "o que você pensa é o que você obtém".',

        // Capacidade narrativa multi-planos fluida
        multiShotNarrativeTitle: 'Capacidade Narrativa Multi-Planos Fluida',
        multiShotNarrativeDescription: 'Suporta planejamento automático de planos gerais, primeiros planos e outros ângulos de câmera, com transições suaves, dando aos vídeos qualidade cinematográfica.',

        // Realismo de detalhes e consistência de estilo
        detailRealismTitle: 'Realismo de Detalhes e Consistência de Estilo',
        detailRealismDescription: 'Otimiza a expressividade de detalhes sutis como características faciais e fios de cabelo, garantindo ao mesmo tempo qualidade de imagem estável e reprodução altamente precisa do estilo de imagem de referência.',

        // Estabilidade aprimorada de movimentos complexos
        complexMotionStabilityTitle: 'Estabilidade Aprimorada de Movimentos Complexos',
        complexMotionStabilityDescription: 'Simula trajetórias de movimento baseadas em leis físicas, mantendo visuais estáveis e suaves mesmo em cenários de alta velocidade ou extremos.',

        // Seção como usar
        howToUseTitle: 'Como Usar',
        step1Title: 'Selecionar Modelo Seedance 1.0 Pro Fast',
        step1Description: 'Vá para a página <span class="highlight-text">"Geração de Vídeo AI"</span> e clique em "Seedance 1.0 Pro Fast" no menu suspenso de modelos.',
        step2Title: 'Insira seu Conteúdo Criativo',
        step2Description: 'Descreva o que você quer gerar ou carregue imagens para converter e escolha seus estilos e efeitos preferidos.',
        step3Title: 'Baixe seu Vídeo',
        step3Description: 'Clique em "Criar" para baixar ou compartilhar o vídeo otimizado gerado.',

        // Seção de vídeos do YouTube
        youtubeTitle: 'Vídeos do YouTube sobre o Modelo Seedance 1.0 Pro Fast',

        // Seção de postagens X
        xPostsTitle: 'Postagens X Populares sobre o Modelo Seedance 1.0 Pro Fast',

        // Seção explorar outros modelos
        exploreModelsTitle: 'Explorar Outros Modelos',
        seedanceTitle: 'Gerador de Vídeo AI Seedance',
        hailuo23Title: 'Gerador de Vídeo AI Hailuo 2.3',
        sora2Title: 'Gerador de Vídeo AI OpenAI Sora-2',

        // Seção FAQ
        faqTitle: 'Perguntas Frequentes',
        faq1Question: 'Para quem o Seedance 1.0 Pro Fast é adequado?',
        faq1Answer: 'É adequado para criadores, PMEs e equipes de mídia própria que precisam gerar vídeos com frequência, especialmente em cenários focados em custo-benefício e eficiência de geração.',
        
        faq2Question: 'Como experimentar o modelo?',
        faq2Answer: 'O modelo foi lançado na plataforma Volcano Ark e os usuários podem experimentá-lo diretamente através da entrada de experiência fornecida pela plataforma.',
        
        faq3Question: 'Pro Fast sacrifica qualidade em comparação com a versão Pro?',
        faq3Answer: 'Não. Ao aumentar a velocidade e reduzir custos, o Pro Fast otimizou o seguimento de instruções e a expressividade de detalhes, mantendo saída de alta qualidade na maioria dos cenários.',
        
        faq4Question: 'Qual duração e resolução de vídeo são suportadas?',
        faq4Answer: 'Suporta geração de vídeos de qualquer duração entre 2 e 12 segundos, com opções de resolução flexíveis de 720P ou 1080P.',
        
        faq5Question: 'Suporta imagem para vídeo? Como é o efeito?',
        faq5Answer: 'Sim. O Pro Fast tem efeitos significativos na geração de imagem para vídeo, especialmente superior a modelos internacionais similares em restauração de detalhes e consistência de estilo.',

        // Seção CTA
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente o Seedance 1.0 Pro Fast agora e crie conteúdo de vídeo de nível profissional de forma eficiente',
        ctaButton: 'Experimente Seedance 1.0 Pro Fast no 微鲤AI',
        ctaDisclaimer: 'Não é necessário cartão de crédito',

        // Relacionado à reprodução de vídeo
        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadError: 'Falha ao carregar vídeo',
        videoReload: 'Recarregar',
    },
    it: {
        // Titolo e descrizione della pagina
        pageTitle: 'Generatore Video AI Seedance 1.0 Pro Fast - Piattaforma di Creazione Video AI Volcano Engine',
        pageDescription: 'Sperimenta il generatore video Seedance 1.0 Pro Fast con miglioramenti rivoluzionari nella velocità di generazione e nell\'efficienza dei costi. Analisi precisa delle istruzioni, narrazione multi-inquadratura fluida e alto realismo dei dettagli per aiutare aziende e creatori a produrre contenuti video su larga scala in modo efficiente.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, generatore video AI, creazione video, generazione video veloce, video AI gratuito, 微鲤AI',

        // Sezione generatore
        generatorTitle: 'Generatore Video AI Seedance 1.0 Pro Fast',
        generatorDescription: 'Doubao-Seedance-1.0-pro-fast è un <span class="highlight-bold">modello di generazione video</span> lanciato ufficialmente da Volcano Engine il 24 ottobre. Ereditando le capacità principali di Seedance 1.0 Pro, ottiene <span class="highlight-bold">miglioramenti rivoluzionari nella velocità di generazione e nell\'efficienza dei costi</span>, aiutando aziende e creatori a produrre contenuti video in modo efficiente e scalabile.',
        
        // Schede
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',

        // Sezione caratteristiche principali
        coreFeaturesTitle: 'Caratteristiche Principali di Seedance 1.0 Pro Fast',

        // Analisi ed esecuzione precisa delle istruzioni
        preciseInstructionTitle: 'Analisi ed Esecuzione Precisa delle Istruzioni',
        preciseInstructionDescription: 'Attraverso una comprensione semantica profonda, il modello può dedurre intelligentemente l\'intenzione dell\'azione, la logica della scena e le transizioni delle inquadrature, ottenendo risultati di generazione "quello che pensi è quello che ottieni".',

        // Capacità narrativa multi-inquadratura fluida
        multiShotNarrativeTitle: 'Capacità Narrativa Multi-Inquadratura Fluida',
        multiShotNarrativeDescription: 'Supporta la pianificazione automatica di inquadrature ampie, primi piani e altri angoli di camera, con transizioni fluide, conferendo ai video qualità cinematografica.',

        // Realismo dei dettagli e coerenza dello stile
        detailRealismTitle: 'Realismo dei Dettagli e Coerenza dello Stile',
        detailRealismDescription: 'Ottimizza l\'espressività di dettagli sottili come lineamenti del viso e ciocche di capelli, garantendo al contempo una qualità dell\'immagine stabile e una riproduzione altamente precisa dello stile dell\'immagine di riferimento.',

        // Stabilità migliorata dei movimenti complessi
        complexMotionStabilityTitle: 'Stabilità Migliorata dei Movimenti Complessi',
        complexMotionStabilityDescription: 'Simula traiettorie di movimento basate su leggi fisiche, mantenendo immagini stabili e fluide anche in scenari ad alta velocità o estremi.',

        // Sezione come usare
        howToUseTitle: 'Come Usare',
        step1Title: 'Seleziona Modello Seedance 1.0 Pro Fast',
        step1Description: 'Vai alla pagina <span class="highlight-text">"Generazione Video AI"</span> e fai clic su "Seedance 1.0 Pro Fast" nel menu a discesa dei modelli.',
        step2Title: 'Inserisci il tuo Contenuto Creativo',
        step2Description: 'Descrivi cosa vuoi generare o carica immagini da convertire e scegli i tuoi stili ed effetti preferiti.',
        step3Title: 'Scarica il tuo Video',
        step3Description: 'Fai clic su "Crea" per scaricare o condividere il video ottimizzato generato.',

        // Sezione video YouTube
        youtubeTitle: 'Video YouTube sul Modello Seedance 1.0 Pro Fast',

        // Sezione post X
        xPostsTitle: 'Post X Popolari sul Modello Seedance 1.0 Pro Fast',

        // Sezione esplora altri modelli
        exploreModelsTitle: 'Esplora Altri Modelli',
        seedanceTitle: 'Generatore Video AI Seedance',
        hailuo23Title: 'Generatore Video AI Hailuo 2.3',
        sora2Title: 'Generatore Video AI OpenAI Sora-2',

        // Sezione FAQ
        faqTitle: 'Domande Frequenti',
        faq1Question: 'Per chi è adatto Seedance 1.0 Pro Fast?',
        faq1Answer: 'È adatto per creatori, PMI e team di media propri che devono generare video frequentemente, specialmente in scenari focalizzati sull\'efficienza dei costi e sull\'efficienza di generazione.',
        
        faq2Question: 'Come sperimentare il modello?',
        faq2Answer: 'Il modello è stato lanciato sulla piattaforma Volcano Ark e gli utenti possono provarlo direttamente tramite l\'ingresso di esperienza fornito dalla piattaforma.',
        
        faq3Question: 'Pro Fast sacrifica la qualità rispetto alla versione Pro?',
        faq3Answer: 'No. Aumentando la velocità e riducendo i costi, Pro Fast ha ottimizzato il rispetto delle istruzioni e l\'espressività dei dettagli, mantenendo un output di alta qualità nella maggior parte degli scenari.',
        
        faq4Question: 'Quale durata e risoluzione video sono supportate?',
        faq4Answer: 'Supporta la generazione di video di qualsiasi durata tra 2 e 12 secondi, con opzioni di risoluzione flessibili di 720P o 1080P.',
        
        faq5Question: 'Supporta immagine a video? Come è l\'effetto?',
        faq5Answer: 'Sì. Pro Fast ha effetti significativi nella generazione da immagine a video, specialmente superiore a modelli internazionali simili nel ripristino dei dettagli e nella coerenza dello stile.',

        // Sezione CTA
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaDescription: 'Sperimenta Seedance 1.0 Pro Fast ora e crea contenuti video di livello professionale in modo efficiente',
        ctaButton: 'Prova Seedance 1.0 Pro Fast su 微鲤AI',
        ctaDisclaimer: 'Non è richiesta carta di credito',

        // Relativo alla riproduzione video
        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadError: 'Caricamento video fallito',
        videoReload: 'Ricarica',
    },
    ar: {
        // عنوان ووصف الصفحة
        pageTitle: 'مولد الفيديو بالذكاء الاصطناعي Seedance 1.0 Pro Fast - منصة إنشاء الفيديو بالذكاء الاصطناعي Volcano Engine',
        pageDescription: 'جرب مولد الفيديو Seedance 1.0 Pro Fast مع تحسينات ثورية في سرعة التوليد وفعالية التكلفة. تحليل دقيق للتعليمات، سرد متعدد اللقطات سلس، وواقعية عالية للتفاصيل لمساعدة الشركات والمبدعين على إنتاج محتوى فيديو على نطاق واسع بكفاءة.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, مولد فيديو بالذكاء الاصطناعي, إنشاء فيديو, توليد فيديو سريع, فيديو بالذكاء الاصطناعي مجاني, 微鲤AI',

        // قسم المولد
        generatorTitle: 'مولد الفيديو بالذكاء الاصطناعي Seedance 1.0 Pro Fast',
        generatorDescription: 'Doubao-Seedance-1.0-pro-fast هو <span class="highlight-bold">نموذج توليد فيديو</span> تم إطلاقه رسميًا بواسطة Volcano Engine في 24 أكتوبر. وراثة القدرات الأساسية من Seedance 1.0 Pro، يحقق <span class="highlight-bold">تحسينات ثورية في سرعة التوليد وفعالية التكلفة</span>، مما يساعد الشركات والمبدعين على إنتاج محتوى فيديو بكفاءة وقابلية للتوسع.',
        
        // علامات التبويب
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',

        // قسم الميزات الأساسية
        coreFeaturesTitle: 'الميزات الأساسية لـ Seedance 1.0 Pro Fast',

        // تحليل وتنفيذ دقيق للتعليمات
        preciseInstructionTitle: 'تحليل وتنفيذ دقيق للتعليمات',
        preciseInstructionDescription: 'من خلال الفهم الدلالي العميق، يمكن للنموذج استنتاج نية الحركة ومنطق المشهد وانتقالات اللقطات بذكاء، محققًا نتائج توليد "ما تفكر فيه هو ما تحصل عليه".',

        // قدرة السرد متعدد اللقطات السلس
        multiShotNarrativeTitle: 'قدرة السرد متعدد اللقطات السلس',
        multiShotNarrativeDescription: 'يدعم التخطيط التلقائي للقطات الواسعة واللقطات القريبة وزوايا الكاميرا الأخرى، مع انتقالات سلسة، مما يمنح مقاطع الفيديو جودة سينمائية.',

        // واقعية التفاصيل واتساق الأسلوب
        detailRealismTitle: 'واقعية التفاصيل واتساق الأسلوب',
        detailRealismDescription: 'يحسن التعبيرية للتفاصيل الدقيقة مثل ملامح الوجه وخصلات الشعر، مع ضمان جودة صورة مستقرة وإعادة إنتاج دقيقة للغاية لأسلوب الصورة المرجعية.',

        // استقرار محسّن للحركات المعقدة
        complexMotionStabilityTitle: 'استقرار محسّن للحركات المعقدة',
        complexMotionStabilityDescription: 'يحاكي مسارات الحركة بناءً على القوانين الفيزيائية، مع الحفاظ على صور مستقرة وسلسة حتى في سيناريوهات السرعة العالية أو الظروف القصوى.',

        // قسم كيفية الاستخدام
        howToUseTitle: 'كيفية الاستخدام',
        step1Title: 'اختر نموذج Seedance 1.0 Pro Fast',
        step1Description: 'انتقل إلى صفحة <span class="highlight-text">"توليد الفيديو بالذكاء الاصطناعي"</span> ثم انقر على "Seedance 1.0 Pro Fast" في القائمة المنسدلة للنماذج.',
        step2Title: 'أدخل محتواك الإبداعي',
        step2Description: 'صف ما تريد توليده أو قم بتحميل الصور للتحويل واختر الأنماط والتأثيرات المفضلة لديك.',
        step3Title: 'قم بتنزيل الفيديو الخاص بك',
        step3Description: 'انقر على "إنشاء" لتنزيل أو مشاركة الفيديو المحسّن الذي تم توليده.',

        // قسم فيديوهات YouTube
        youtubeTitle: 'فيديوهات YouTube حول نموذج Seedance 1.0 Pro Fast',

        // قسم منشورات X
        xPostsTitle: 'منشورات X الشائعة حول نموذج Seedance 1.0 Pro Fast',

        // قسم استكشاف نماذج أخرى
        exploreModelsTitle: 'استكشف نماذج أخرى',
        seedanceTitle: 'مولد الفيديو بالذكاء الاصطناعي Seedance',
        hailuo23Title: 'مولد الفيديو بالذكاء الاصطناعي Hailuo 2.3',
        sora2Title: 'مولد الفيديو بالذكاء الاصطناعي OpenAI Sora-2',

        // قسم الأسئلة الشائعة
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'لمن يناسب Seedance 1.0 Pro Fast؟',
        faq1Answer: 'إنه مناسب للمبدعين والشركات الصغيرة والمتوسطة وفرق الإعلام الذاتي التي تحتاج إلى توليد مقاطع فيديو بشكل متكرر، خاصة في السيناريوهات التي تركز على فعالية التكلفة وكفاءة التوليد.',
        
        faq2Question: 'كيف يمكن تجربة النموذج؟',
        faq2Answer: 'تم إطلاق النموذج على منصة Volcano Ark ويمكن للمستخدمين تجربته مباشرة من خلال مدخل التجربة المقدم من المنصة.',
        
        faq3Question: 'هل يضحي Pro Fast بالجودة مقارنة بإصدار Pro؟',
        faq3Answer: 'لا. بينما يزيد السرعة ويقلل التكاليف، قام Pro Fast بتحسين اتباع التعليمات والتعبيرية التفصيلية، مع الحفاظ على إخراج عالي الجودة في معظم السيناريوهات.',
        
        faq4Question: 'ما هي مدة الفيديو ودقته المدعومة؟',
        faq4Answer: 'يدعم توليد مقاطع فيديو بأي مدة بين 2 و 12 ثانية، مع خيارات دقة مرنة من 720P أو 1080P.',
        
        faq5Question: 'هل يدعم الصورة إلى الفيديو؟ ما هو التأثير؟',
        faq5Answer: 'نعم. لدى Pro Fast تأثيرات كبيرة في توليد الصورة إلى الفيديو، متفوقًا بشكل خاص على النماذج الدولية المماثلة في استعادة التفاصيل واتساق الأسلوب.',

        // قسم CTA
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaDescription: 'جرب Seedance 1.0 Pro Fast الآن وقم بإنشاء محتوى فيديو بمستوى احترافي بكفاءة',
        ctaButton: 'جرب Seedance 1.0 Pro Fast على 微鲤AI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',

        // متعلق بتشغيل الفيديو
        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        },
    th: {
        // Page title and description
        pageTitle: 'เครื่องมือสร้างวิดีโอ Seedance 1.0 Pro Fast - แพลตฟอร์มสร้างวิดีโอ AI Volcano Engine',
        pageDescription: 'สัมผัสเครื่องมือสร้างวิดีโอ Seedance 1.0 Pro Fast ที่อัปเกรดความเร็วและความคุ้มค่าอย่างก้าวกระโดด การแยกคำสั่งอย่างแม่นยำ การเล่าเรื่องหลายช็อตที่ลื่นไหล และความสมจริงของรายละเอียด ช่วยให้ธุรกิจและครีเอเตอร์ขยายการสร้างวิดีโอได้อย่างมีประสิทธิภาพ ลองโมเดลสร้างวิดีโอ Volcano Engine ฟรี',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, เครื่องมือสร้างวิดีโอ AI, การสร้างวิดีโอ, สร้างวิดีโอรวดเร็ว, วิดีโอ AI ฟรี, 微鲤AI',

        // Generator section
        generatorTitle: 'เครื่องมือสร้างวิดีโอ Seedance 1.0 Pro Fast',
        generatorDescription: 'Seedance 1.0 Pro Fast คือ <span class="highlight-bold">โมเดลสร้างวิดีโอ</span> ที่ Volcano Engine เปิดตัวอย่างเป็นทางการเมื่อวันที่ 24 ตุลาคม โดยต่อยอดจากความสามารถหลักของ Seedance 1.0 Pro และทำให้เกิด <span class="highlight-bold">การอัปเกรดด้านความเร็วและความคุ้มค่าอย่างก้าวกระโดด</span> ช่วยให้ธุรกิจและครีเอเตอร์ขยายการผลิตวิดีโอได้อย่างมีประสิทธิภาพ',
        
        // Tabs
        tabImageToVideo: 'ภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',

        // Core features section
        coreFeaturesTitle: 'คุณสมบัติเด่นของ Seedance 1.0 Pro Fast',

        // Precise instruction parsing and execution
        preciseInstructionTitle: 'การแยกและปฏิบัติตามคำสั่งอย่างแม่นยำ',
        preciseInstructionDescription: 'ด้วยความเข้าใจเชิงความหมายเชิงลึก โมเดลสามารถอนุมานเจตนาการกระทำ ตรรกะของฉาก และการเปลี่ยนช็อตอย่างชาญฉลาด ให้ผลลัพธ์แบบ “คิดอย่างไร ได้อย่างนั้น”',

        // Seamless multi-shot narrative capability
        multiShotNarrativeTitle: 'ความสามารถเล่าเรื่องหลายช็อตอย่างลื่นไหล',
        multiShotNarrativeDescription: 'รองรับการวางแผนช็อตไกล ช็อตใกล้ และมุมกล้องอื่นๆ อัตโนมัติ พร้อมการเปลี่ยนผ่านที่ราบรื่น ให้คุณภาพแบบภาพยนตร์',

        // Detail realism and style consistency
        detailRealismTitle: 'ความสมจริงของรายละเอียดและความสม่ำเสมอของสไตล์',
        detailRealismDescription: 'เพิ่มความชัดของรายละเอียดเล็กๆ เช่น ใบหน้าและเส้นผม พร้อมรักษาคุณภาพภาพให้เสถียรและถอดแบบสไตล์ภาพอ้างอิงได้อย่างแม่นยำสูง',

        // Enhanced complex motion stability
        complexMotionStabilityTitle: 'ความเสถียรของการเคลื่อนไหวซับซ้อนที่ดีขึ้น',
        complexMotionStabilityDescription: 'จำลองเส้นทางการเคลื่อนไหวตามกฎฟิสิกส์ ทำให้ภาพลื่นไหลและเสถียรแม้ในฉากความเร็วสูงหรือสถานการณ์สุดขั้ว',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        step1Title: 'เลือกโมเดล Seedance 1.0 Pro Fast',
        step1Description: 'ไปที่หน้า <span class="highlight-text">"AI Video Generation"</span> จากนั้นคลิก "Seedance 1.0 Pro Fast" ในเมนูเลือกโมเดล',
        step2Title: 'ป้อนเนื้อหาสร้างสรรค์ของคุณ',
        step2Description: 'อธิบายสิ่งที่ต้องการสร้าง หรืออัปโหลดภาพเพื่อแปลง และเลือกสไตล์กับเอฟเฟกต์ที่ต้องการ',
        step3Title: 'ดาวน์โหลดวิดีโอของคุณ',
        step3Description: 'คลิก "Create" เพื่อดาวน์โหลดหรือแชร์วิดีโอที่ปรับแต่งแล้ว',

        // YouTube videos section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดล Seedance 1.0 Pro Fast',

        // X Posts section
        xPostsTitle: 'โพสต์ X ยอดนิยมเกี่ยวกับโมเดล Seedance 1.0 Pro Fast',

        // Explore other models section
        exploreModelsTitle: 'สำรวจโมเดลอื่นๆ',
        seedanceTitle: 'เครื่องมือสร้างวิดีโอ AI Seedance',
        hailuo23Title: 'เครื่องมือสร้างวิดีโอ AI Hailuo 2.3',
        sora2Title: 'เครื่องมือสร้างวิดีโอ AI OpenAI Sora-2',

        // FAQ section
        faqTitle: 'คำถามที่พบบ่อย',
        faq1Question: 'Seedance 1.0 Pro Fast เหมาะกับใคร?',
        faq1Answer: 'เหมาะสำหรับครีเอเตอร์ ธุรกิจขนาดกลางและเล็ก และทีมสื่อที่ต้องสร้างวิดีโอบ่อย โดยเฉพาะกรณีที่เน้นความคุ้มค่าและประสิทธิภาพการสร้าง',
        
        faq2Question: 'จะทดลองใช้โมเดลได้อย่างไร?',
        faq2Answer: 'โมเดลถูกเปิดตัวบนแพลตฟอร์ม Volcano Ark และผู้ใช้สามารถทดลองได้โดยตรงผ่านช่องทางทดลองที่แพลตฟอร์มให้ไว้',
        
        faq3Question: 'Pro Fast ลดคุณภาพเมื่อเทียบกับรุ่น Pro หรือไม่?',
        faq3Answer: 'ไม่ แม้จะเพิ่มความเร็วและลดต้นทุน แต่ Pro Fast ได้ปรับปรุงการทำตามคำสั่งและความละเอียดของรายละเอียด พร้อมรักษาคุณภาพสูงในสถานการณ์ส่วนใหญ่',
        
        faq4Question: 'รองรับความยาวและความละเอียดวิดีโอเท่าไร?',
        faq4Answer: 'รองรับวิดีโอความยาว 2-12 วินาที และเลือกความละเอียดได้ทั้ง 720P หรือ 1080P',
        
        faq5Question: 'รองรับภาพเป็นวิดีโอไหม? ผลลัพธ์เป็นอย่างไร?',
        faq5Answer: 'รองรับ Pro Fast มีประสิทธิภาพสูงในการสร้างวิดีโอจากภาพ โดยเฉพาะด้านการคืนรายละเอียดและความสม่ำเสมอของสไตล์ ซึ่งเหนือกว่ารุ่นสากลที่คล้ายกัน',

        // CTA section
        ctaTitle: 'พร้อมเริ่มสร้างสรรค์แล้วหรือยัง?',
        ctaDescription: 'ลอง Seedance 1.0 Pro Fast ตอนนี้และสร้างคอนเทนต์วิดีโอระดับมืออาชีพได้อย่างมีประสิทธิภาพ',
        ctaButton: 'ลอง Seedance 1.0 Pro Fast บน 微鲤AI',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',

        // Video playback related
        videoNotSupported: 'เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ',
        videoLoadError: 'โหลดวิดีโอล้มเหลว',
        videoReload: 'โหลดใหม่',
        },
    da: {
        // Page title and description
        pageTitle: 'Seedance 1.0 Pro Fast videgenerator - Volcano Engine AI videoplatform',
        pageDescription: 'Oplev Seedance 1.0 Pro Fast videgenerator med banebrydende opgraderinger i hastighed og omkostningseffektivitet. Præcis instruktionsfortolkning, sømløs multi-shot fortælling og stærk detaljerealisme hjælper virksomheder og skabere med effektivt at skalere videoproduktion. Prøv Volcano Engine videomodellen gratis.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, AI videgenerator, videoproduktion, hurtig videogenerering, gratis AI-video, 微鲤AI',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Fast videgenerator',
        generatorDescription: 'Seedance 1.0 Pro Fast er en <span class="highlight-bold">videogenereringsmodel</span> officielt lanceret af Volcano Engine den 24. oktober. Med udgangspunkt i kernekapaciteterne fra Seedance 1.0 Pro opnår den <span class="highlight-bold">banebrydende opgraderinger i hastighed og omkostningseffektivitet</span>, som hjælper virksomheder og skabere med effektivt at skalere videoproduktionen.',
        
        // Tabs
        tabImageToVideo: 'Billede til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Seedance 1.0 Pro Fast kernefunktioner',

        // Precise instruction parsing and execution
        preciseInstructionTitle: 'Præcis instruktionsfortolkning og udførelse',
        preciseInstructionDescription: 'Med dyb semantisk forståelse kan modellen intelligent udlede handlingsintention, scenelogik og shot-overgange og dermed levere resultater som “det du tænker, er det du får”.',

        // Seamless multi-shot narrative capability
        multiShotNarrativeTitle: 'Sømløs multi-shot fortælleevne',
        multiShotNarrativeDescription: 'Understøtter automatisk planlægning af totalbilleder, close-ups og andre kameravinkler med glidende overgange, hvilket giver filmisk kvalitet.',

        // Detail realism and style consistency
        detailRealismTitle: 'Detaljerealisme og stilkonsistens',
        detailRealismDescription: 'Optimerer udtrykket i fine detaljer som ansigtstræk og hårstrå, samtidig med at billedkvaliteten er stabil og reference-stilen reproduceres meget præcist.',

        // Enhanced complex motion stability
        complexMotionStabilityTitle: 'Forbedret stabilitet ved kompleks bevægelse',
        complexMotionStabilityDescription: 'Simulerer bevægelsesbaner ud fra fysiske love og bevarer stabile og glatte visuals selv ved høj hastighed eller ekstreme scenarier.',

        // How to use section
        howToUseTitle: 'Sådan bruges',
        step1Title: 'Vælg Seedance 1.0 Pro Fast-model',
        step1Description: 'Gå til <span class="highlight-text">"AI Video Generation"</span>-siden, og klik derefter "Seedance 1.0 Pro Fast" i modelrullemenuen.',
        step2Title: 'Indtast dit kreative indhold',
        step2Description: 'Beskriv hvad du vil generere, eller upload billeder til konvertering, og vælg dine foretrukne stilarter og effekter.',
        step3Title: 'Download din video',
        step3Description: 'Klik på "Create" for at downloade eller dele den genererede, optimerede video.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Seedance 1.0 Pro Fast-modellen',

        // X Posts section
        xPostsTitle: 'Populære X-opslag om Seedance 1.0 Pro Fast-modellen',

        // Explore other models section
        exploreModelsTitle: 'Udforsk andre modeller',
        seedanceTitle: 'Seedance AI-videgenerator',
        hailuo23Title: 'Hailuo 2.3 AI-videgenerator',
        sora2Title: 'OpenAI Sora-2 AI-videgenerator',

        // FAQ section
        faqTitle: 'Ofte stillede spørgsmål',
        faq1Question: 'Hvem er Seedance 1.0 Pro Fast egnet til?',
        faq1Answer: 'Den er velegnet til skabere, SMV\'er og self-media teams, der ofte skal generere videoer, især i scenarier hvor omkostningseffektivitet og genereringseffektivitet er i fokus.',
        
        faq2Question: 'Hvordan kan man prøve modellen?',
        faq2Answer: 'Modellen er lanceret på Volcano Ark-platformen, og brugere kan prøve den direkte via platformens oplevelsesindgang.',
        
        faq3Question: 'Går Pro Fast på kompromis med kvaliteten sammenlignet med Pro-versionen?',
        faq3Answer: 'Nej. Mens hastigheden øges og omkostninger reduceres, har Pro Fast optimeret instruktionsfølgning og detaljeudtryk og bevarer høj kvalitet i de fleste scenarier.',
        
        faq4Question: 'Hvilken videolængde og opløsning understøttes?',
        faq4Answer: 'Understøtter videoer mellem 2-12 sekunder med fleksible opløsningsvalg på 720P eller 1080P.',
        
        faq5Question: 'Understøtter den billede-til-video? Hvordan er effekten?',
        faq5Answer: 'Ja. Pro Fast har markante resultater i billede-til-video-generering, især bedre end tilsvarende internationale modeller i detaljegengivelse og stilkonsistens.',

        // CTA section
        ctaTitle: 'Klar til at skabe?',
        ctaDescription: 'Prøv Seedance 1.0 Pro Fast nu og skab professionelt videomateriale effektivt',
        ctaButton: 'Prøv Seedance 1.0 Pro Fast på 微鲤AI',
        ctaDisclaimer: 'Intet kreditkort kræves',

        // Video playback related
        videoNotSupported: 'Din browser understøtter ikke videoafspilning',
        videoLoadError: 'Videoen kunne ikke indlæses',
        videoReload: 'Genindlæs',
        },
    no: {
        // Page title and description
        pageTitle: 'Seedance 1.0 Pro Fast videogenerator - Volcano Engine AI videoplattform',
        pageDescription: 'Opplev Seedance 1.0 Pro Fast videogenerator med gjennombrudd i genereringshastighet og kostnadseffektivitet. Presis instruksjonsfortolkning, sømløs multi-shot fortelling og sterk detaljrealisme hjelper bedrifter og skapere å skalere videoproduksjon effektivt. Prøv Volcano Engine videomodell gratis.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, AI videgenerator, videoproduksjon, rask videogenerering, gratis AI-video, 微鲤AI',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Fast videogenerator',
        generatorDescription: 'Seedance 1.0 Pro Fast er en <span class="highlight-bold">videogenereringsmodell</span> offisielt lansert av Volcano Engine 24. oktober. Med utgangspunkt i kjernekapasitetene til Seedance 1.0 Pro oppnår den <span class="highlight-bold">gjennombrudd i genereringshastighet og kostnadseffektivitet</span>, og hjelper bedrifter og skapere med å skalere videoproduksjon effektivt.',
        
        // Tabs
        tabImageToVideo: 'Bilde til video',
        tabTextToVideo: 'Tekst til video',

        // Core features section
        coreFeaturesTitle: 'Seedance 1.0 Pro Fast kjernefunksjoner',

        // Precise instruction parsing and execution
        preciseInstructionTitle: 'Presis instruksjonsfortolkning og utførelse',
        preciseInstructionDescription: 'Med dyp semantisk forståelse kan modellen intelligent utlede handlingsintensjon, scenelogikk og shot-overganger, og gi resultater der “det du tenker, er det du får”.',

        // Seamless multi-shot narrative capability
        multiShotNarrativeTitle: 'Sømløs multi-shot fortellerkapasitet',
        multiShotNarrativeDescription: 'Støtter automatisk planlegging av totalbilder, nærbilder og andre kameravinkler, med glatte overganger som gir filmatisk kvalitet.',

        // Detail realism and style consistency
        detailRealismTitle: 'Detaljerealisme og stilkonsistens',
        detailRealismDescription: 'Optimaliserer uttrykket i fine detaljer som ansiktstrekk og hårstrå, samtidig som bildekvaliteten holdes stabil og referansestil gjengis svært nøyaktig.',

        // Enhanced complex motion stability
        complexMotionStabilityTitle: 'Forbedret stabilitet ved kompleks bevegelse',
        complexMotionStabilityDescription: 'Simulerer bevegelsesbaner basert på fysiske lover og holder visuelle uttrykk stabile og glatte selv i høy hastighet eller ekstreme scenarier.',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        step1Title: 'Velg Seedance 1.0 Pro Fast-modellen',
        step1Description: 'Gå til <span class="highlight-text">"AI Video Generation"</span>-siden, og klikk deretter "Seedance 1.0 Pro Fast" i modellmenyen.',
        step2Title: 'Skriv inn ditt kreative innhold',
        step2Description: 'Beskriv hva du vil generere, eller last opp bilder for konvertering, og velg ønskede stiler og effekter.',
        step3Title: 'Last ned videoen din',
        step3Description: 'Klikk "Create" for å laste ned eller dele den genererte optimaliserte videoen.',

        // YouTube videos section
        youtubeTitle: 'YouTube-videoer om Seedance 1.0 Pro Fast-modellen',

        // X Posts section
        xPostsTitle: 'Populære X-innlegg om Seedance 1.0 Pro Fast-modellen',

        // Explore other models section
        exploreModelsTitle: 'Utforsk andre modeller',
        seedanceTitle: 'Seedance AI-videogenerator',
        hailuo23Title: 'Hailuo 2.3 AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',

        // FAQ section
        faqTitle: 'Ofte stilte spørsmål',
        faq1Question: 'Hvem er Seedance 1.0 Pro Fast egnet for?',
        faq1Answer: 'Den passer for skapere, SMB-er og self-media-team som ofte må generere videoer, spesielt i scenarier med fokus på kostnadseffektivitet og genereringseffektivitet.',
        
        faq2Question: 'Hvordan kan man prøve modellen?',
        faq2Answer: 'Modellen er lansert på Volcano Ark-plattformen, og brukere kan prøve den direkte via plattformens inngang for prøving.',
        
        faq3Question: 'Går Pro Fast på bekostning av kvalitet sammenlignet med Pro-versjonen?',
        faq3Answer: 'Nei. Selv om hastigheten økes og kostnadene reduseres, har Pro Fast optimalisert instruksjonsfølgning og detaljuttrykk og opprettholder høy kvalitet i de fleste scenarier.',
        
        faq4Question: 'Hvilken videolengde og oppløsning støttes?',
        faq4Answer: 'Støtter videoer fra 2–12 sekunder, med fleksible oppløsninger på 720P eller 1080P.',
        
        faq5Question: 'Støtter den bilde-til-video? Hvordan er resultatet?',
        faq5Answer: 'Ja. Pro Fast har sterke resultater i bilde-til-video, spesielt bedre enn tilsvarende internasjonale modeller når det gjelder detaljgjenoppretting og stilkonsistens.',

        // CTA section
        ctaTitle: 'Klar til å skape?',
        ctaDescription: 'Prøv Seedance 1.0 Pro Fast nå og skap profesjonelt videoinnhold effektivt',
        ctaButton: 'Prøv Seedance 1.0 Pro Fast på 微鲤AI',
        ctaDisclaimer: 'Ingen kredittkort kreves',

        // Video playback related
        videoNotSupported: 'Nettleseren din støtter ikke videoavspilling',
        videoLoadError: 'Videoen kunne ikke lastes',
        videoReload: 'Last på nytt',
        },
    nl: {
        // Page title and description
        pageTitle: 'Seedance 1.0 Pro Fast videgenerator - Volcano Engine AI videoplatform',
        pageDescription: 'Ervaar de Seedance 1.0 Pro Fast videgenerator met doorbraaksprongen in snelheid en kostenefficiëntie. Nauwkeurige instructieparsing, naadloze multi-shot narratief en sterke detailrealisme helpen bedrijven en creators video-productie efficiënt op te schalen. Probeer de Volcano Engine video-generatiemodel gratis.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, AI-videogenerator, videocreatie, snelle videogeneratie, gratis AI-video, 微鲤AI',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Fast videgenerator',
        generatorDescription: 'Seedance 1.0 Pro Fast is een <span class="highlight-bold">videogeneratiemodel</span> dat op 24 oktober officieel door Volcano Engine is gelanceerd. Voortbouwend op de kerncapaciteiten van Seedance 1.0 Pro bereikt het <span class="highlight-bold">doorbraaksprongen in snelheid en kostenefficiëntie</span>, waardoor bedrijven en creators de productie van videocontent efficiënt kunnen opschalen.',
        
        // Tabs
        tabImageToVideo: 'Beeld naar video',
        tabTextToVideo: 'Tekst naar video',

        // Core features section
        coreFeaturesTitle: 'Seedance 1.0 Pro Fast kernfuncties',

        // Precise instruction parsing and execution
        preciseInstructionTitle: 'Nauwkeurige instructieparsing en uitvoering',
        preciseInstructionDescription: 'Door diep semantisch begrip kan het model actie-intentie, scenelogica en shot-overgangen intelligent afleiden, met resultaten die “wat je denkt is wat je krijgt” benaderen.',

        // Seamless multi-shot narrative capability
        multiShotNarrativeTitle: 'Naadloze multi-shot narratieve capaciteit',
        multiShotNarrativeDescription: 'Ondersteunt automatische planning van totaalshots, close-ups en andere camerahoeken met soepele overgangen, wat een filmische kwaliteit geeft.',

        // Detail realism and style consistency
        detailRealismTitle: 'Detailrealisme en stijlconsistentie',
        detailRealismDescription: 'Optimaliseert de expressiviteit van subtiele details zoals gelaatstrekken en haarlokken, terwijl de beeldkwaliteit stabiel blijft en referentiestijl zeer nauwkeurig wordt gereproduceerd.',

        // Enhanced complex motion stability
        complexMotionStabilityTitle: 'Verbeterde stabiliteit bij complexe beweging',
        complexMotionStabilityDescription: 'Simuleert bewegingsbanen op basis van natuurkundige wetten en behoudt stabiele, vloeiende beelden zelfs bij hoge snelheid of extreme scenario’s.',

        // How to use section
        howToUseTitle: 'Hoe te gebruiken',
        step1Title: 'Selecteer het Seedance 1.0 Pro Fast-model',
        step1Description: 'Ga naar de <span class="highlight-text">"AI Video Generation"</span>-pagina en klik vervolgens op "Seedance 1.0 Pro Fast" in het model-dropdownmenu.',
        step2Title: 'Voer je creatieve content in',
        step2Description: 'Beschrijf wat je wilt genereren of upload afbeeldingen voor conversie en kies je gewenste stijlen en effecten.',
        step3Title: 'Download je video',
        step3Description: 'Klik op "Create" om de gegenereerde geoptimaliseerde video te downloaden of te delen.',

        // YouTube videos section
        youtubeTitle: 'YouTube-video\'s over het Seedance 1.0 Pro Fast-model',

        // X Posts section
        xPostsTitle: 'Populaire X-posts over het Seedance 1.0 Pro Fast-model',

        // Explore other models section
        exploreModelsTitle: 'Ontdek andere modellen',
        seedanceTitle: 'Seedance AI-videogenerator',
        hailuo23Title: 'Hailuo 2.3 AI-videogenerator',
        sora2Title: 'OpenAI Sora-2 AI-videogenerator',

        // FAQ section
        faqTitle: 'Veelgestelde vragen',
        faq1Question: 'Voor wie is Seedance 1.0 Pro Fast geschikt?',
        faq1Answer: 'Het is geschikt voor creators, MKB\'s en self-media teams die vaak video\'s moeten genereren, vooral in scenario\'s die focussen op kostenefficiëntie en generatie-efficiëntie.',
        
        faq2Question: 'Hoe kun je het model uitproberen?',
        faq2Answer: 'Het model is gelanceerd op het Volcano Ark-platform en gebruikers kunnen het direct proberen via de proefingang van het platform.',
        
        faq3Question: 'Levert Pro Fast kwaliteit in vergeleken met de Pro-versie?',
        faq3Answer: 'Nee. Terwijl snelheid wordt verhoogd en kosten worden verlaagd, optimaliseert Pro Fast het volgen van instructies en detailuitdrukking, en behoudt het hoge kwaliteit in de meeste scenario\'s.',
        
        faq4Question: 'Welke videoduur en resolutie worden ondersteund?',
        faq4Answer: 'Ondersteunt video\'s van 2–12 seconden, met flexibele resoluties van 720P of 1080P.',
        
        faq5Question: 'Ondersteunt het beeld-naar-video? Hoe is het resultaat?',
        faq5Answer: 'Ja. Pro Fast levert sterke resultaten bij beeld-naar-video, vooral beter dan vergelijkbare internationale modellen in detailherstel en stijlconsistentie.',

        // CTA section
        ctaTitle: 'Klaar om te creëren?',
        ctaDescription: 'Probeer Seedance 1.0 Pro Fast nu en maak efficiënt video-inhoud van professioneel niveau',
        ctaButton: 'Probeer Seedance 1.0 Pro Fast op 微鲤AI',
        ctaDisclaimer: 'Geen creditcard nodig',

        // Video playback related
        videoNotSupported: 'Je browser ondersteunt geen video-afspelen',
        videoLoadError: 'Video kon niet worden geladen',
        videoReload: 'Opnieuw laden',
        },
    id: {
        // Page title and description
        pageTitle: 'Generator Video Seedance 1.0 Pro Fast - Platform Pembuatan Video AI Volcano Engine',
        pageDescription: 'Rasakan generator video Seedance 1.0 Pro Fast dengan peningkatan terobosan pada kecepatan generasi dan efektivitas biaya. Parsing instruksi yang presisi, narasi multi-shot yang mulus, dan realisme detail yang kuat membantu perusahaan dan kreator meningkatkan produksi video secara efisien. Coba model generasi video Volcano Engine secara gratis.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, generator video AI, pembuatan video, generasi video cepat, video AI gratis, 微鲤AI',

        // Generator section
        generatorTitle: 'Generator Video Seedance 1.0 Pro Fast',
        generatorDescription: 'Seedance 1.0 Pro Fast adalah <span class="highlight-bold">model generasi video</span> yang resmi diluncurkan oleh Volcano Engine pada 24 Oktober. Dibangun di atas kemampuan inti Seedance 1.0 Pro, model ini menghadirkan <span class="highlight-bold">peningkatan terobosan dalam kecepatan generasi dan efektivitas biaya</span>, membantu perusahaan dan kreator meningkatkan produksi konten video secara efisien.',
        
        // Tabs
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',

        // Core features section
        coreFeaturesTitle: 'Fitur Inti Seedance 1.0 Pro Fast',

        // Precise instruction parsing and execution
        preciseInstructionTitle: 'Parsing dan eksekusi instruksi yang presisi',
        preciseInstructionDescription: 'Dengan pemahaman semantik yang mendalam, model dapat menurunkan niat aksi, logika adegan, dan transisi shot secara cerdas, menghasilkan output “apa yang Anda bayangkan itulah yang Anda dapatkan”.',

        // Seamless multi-shot narrative capability
        multiShotNarrativeTitle: 'Kemampuan narasi multi-shot yang mulus',
        multiShotNarrativeDescription: 'Mendukung perencanaan otomatis wide shot, close-up, dan sudut kamera lain dengan transisi halus untuk kualitas sinematik.',

        // Detail realism and style consistency
        detailRealismTitle: 'Realisme detail dan konsistensi gaya',
        detailRealismDescription: 'Mengoptimalkan ekspresivitas detail halus seperti fitur wajah dan helai rambut, sekaligus menjaga kualitas gambar stabil dan reproduksi gaya referensi yang sangat akurat.',

        // Enhanced complex motion stability
        complexMotionStabilityTitle: 'Stabilitas gerak kompleks yang ditingkatkan',
        complexMotionStabilityDescription: 'Mensimulasikan lintasan gerak berdasarkan hukum fisika, menjaga visual tetap stabil dan halus bahkan dalam skenario berkecepatan tinggi atau ekstrem.',

        // How to use section
        howToUseTitle: 'Cara menggunakan',
        step1Title: 'Pilih model Seedance 1.0 Pro Fast',
        step1Description: 'Buka halaman <span class="highlight-text">"AI Video Generation"</span>, lalu klik "Seedance 1.0 Pro Fast" pada menu dropdown model.',
        step2Title: 'Masukkan konten kreatif Anda',
        step2Description: 'Jelaskan apa yang ingin Anda buat, atau unggah gambar untuk konversi, lalu pilih gaya dan efek yang Anda inginkan.',
        step3Title: 'Unduh video Anda',
        step3Description: 'Klik "Create" untuk mengunduh atau membagikan video yang telah dioptimalkan.',

        // YouTube videos section
        youtubeTitle: 'Video YouTube tentang model Seedance 1.0 Pro Fast',

        // X Posts section
        xPostsTitle: 'Postingan X populer tentang model Seedance 1.0 Pro Fast',

        // Explore other models section
        exploreModelsTitle: 'Jelajahi model lainnya',
        seedanceTitle: 'Generator Video AI Seedance',
        hailuo23Title: 'Generator Video AI Hailuo 2.3',
        sora2Title: 'Generator Video AI OpenAI Sora-2',

        // FAQ section
        faqTitle: 'Pertanyaan yang sering diajukan',
        faq1Question: 'Untuk siapa Seedance 1.0 Pro Fast cocok?',
        faq1Answer: 'Cocok untuk kreator, UKM, dan tim self-media yang perlu membuat video secara sering, terutama pada skenario yang menekankan efektivitas biaya dan efisiensi generasi.',
        
        faq2Question: 'Bagaimana cara mencoba modelnya?',
        faq2Answer: 'Model ini telah diluncurkan di platform Volcano Ark, dan pengguna dapat mencobanya langsung melalui pintu pengalaman yang disediakan oleh platform.',
        
        faq3Question: 'Apakah Pro Fast mengorbankan kualitas dibanding versi Pro?',
        faq3Answer: 'Tidak. Sambil meningkatkan kecepatan dan menurunkan biaya, Pro Fast mengoptimalkan kepatuhan instruksi dan ekspresivitas detail, serta tetap mempertahankan kualitas tinggi dalam sebagian besar skenario.',
        
        faq4Question: 'Durasi dan resolusi video apa yang didukung?',
        faq4Answer: 'Mendukung video dengan durasi 2–12 detik, dengan pilihan resolusi fleksibel 720P atau 1080P.',
        
        faq5Question: 'Apakah mendukung image-to-video? Bagaimana hasilnya?',
        faq5Answer: 'Ya. Pro Fast memiliki performa kuat dalam generasi image-to-video, terutama unggul dibanding model internasional serupa dalam pemulihan detail dan konsistensi gaya.',

        // CTA section
        ctaTitle: 'Siap mulai berkarya?',
        ctaDescription: 'Coba Seedance 1.0 Pro Fast sekarang dan buat konten video kelas profesional secara efisien',
        ctaButton: 'Coba Seedance 1.0 Pro Fast di 微鲤AI',
        ctaDisclaimer: 'Tidak perlu kartu kredit',

        // Video playback related
        videoNotSupported: 'Browser Anda tidak mendukung pemutaran video',
        videoLoadError: 'Video gagal dimuat',
        videoReload: 'Muat ulang',
        },
    tr: {
        // Page title and description
        pageTitle: 'Seedance 1.0 Pro Fast Video Üretici - Volcano Engine AI Video Oluşturma Platformu',
        pageDescription: 'Seedance 1.0 Pro Fast video üreticisini, üretim hızında ve maliyet verimliliğinde çığır açan yükseltmelerle deneyimleyin. Hassas talimat ayrıştırma, kusursuz çoklu çekim anlatımı ve güçlü detay gerçekçiliği; işletmelerin ve üreticilerin video içerik üretimini verimli biçimde ölçeklemesine yardımcı olur. Volcano Engine video üretim modelini ücretsiz deneyin.',
        pageKeywords: 'Seedance 1.0 Pro Fast, Volcano Engine, AI video üretici, video oluşturma, hızlı video üretimi, ücretsiz AI video, 微鲤AI',

        // Generator section
        generatorTitle: 'Seedance 1.0 Pro Fast Video Üretici',
        generatorDescription: 'Seedance 1.0 Pro Fast, Volcano Engine tarafından 24 Ekim’de resmi olarak lanse edilen bir <span class="highlight-bold">video üretim modelidir</span>. Seedance 1.0 Pro’nun temel yeteneklerini temel alarak <span class="highlight-bold">üretim hızında ve maliyet verimliliğinde çığır açan yükseltmeler</span> sunar ve işletmelerin ile üreticilerin video içerik üretimini verimli biçimde ölçeklemesine yardımcı olur.',
        
        // Tabs
        tabImageToVideo: 'Görüntüden Videoya',
        tabTextToVideo: 'Metinden Videoya',

        // Core features section
        coreFeaturesTitle: 'Seedance 1.0 Pro Fast Temel Özellikleri',

        // Precise instruction parsing and execution
        preciseInstructionTitle: 'Hassas talimat ayrıştırma ve yürütme',
        preciseInstructionDescription: 'Derin anlamsal anlayış sayesinde model, eylem niyetini, sahne mantığını ve çekim geçişlerini akıllıca çıkarır ve “ne düşünürsen onu alırsın” sonuçları sunar.',

        // Seamless multi-shot narrative capability
        multiShotNarrativeTitle: 'Kusursuz çoklu çekim anlatı yeteneği',
        multiShotNarrativeDescription: 'Geniş plan, yakın plan ve diğer kamera açılarını otomatik planlamayı destekler; akıcı geçişlerle videolara sinematik kalite kazandırır.',

        // Detail realism and style consistency
        detailRealismTitle: 'Detay gerçekçiliği ve stil tutarlılığı',
        detailRealismDescription: 'Yüz hatları ve saç telleri gibi ince detayların ifadesini optimize ederken görüntü kalitesini stabil tutar ve referans görüntü stilini yüksek doğrulukla yeniden üretir.',

        // Enhanced complex motion stability
        complexMotionStabilityTitle: 'Gelişmiş karmaşık hareket stabilitesi',
        complexMotionStabilityDescription: 'Fiziksel yasalara dayalı hareket yörüngelerini simüle eder ve yüksek hızlı veya ekstrem senaryolarda bile görselleri stabil ve akıcı tutar.',

        // How to use section
        howToUseTitle: 'Nasıl kullanılır',
        step1Title: 'Seedance 1.0 Pro Fast modelini seçin',
        step1Description: ' <span class="highlight-text">"AI Video Generation"</span> sayfasına gidin, ardından model açılır menüsünden "Seedance 1.0 Pro Fast" seçin.',
        step2Title: 'Yaratıcı içeriğinizi girin',
        step2Description: 'Ne üretmek istediğinizi açıklayın veya dönüşüm için görseller yükleyin ve tercih ettiğiniz stilleri ve efektleri seçin.',
        step3Title: 'Videonuzu indirin',
        step3Description: '"Create" düğmesine tıklayarak oluşturulan optimize videoyu indirin veya paylaşın.',

        // YouTube videos section
        youtubeTitle: 'Seedance 1.0 Pro Fast modeli hakkında YouTube videoları',

        // X Posts section
        xPostsTitle: 'Seedance 1.0 Pro Fast modeli hakkında popüler X gönderileri',

        // Explore other models section
        exploreModelsTitle: 'Diğer modelleri keşfedin',
        seedanceTitle: 'Seedance AI Video Üretici',
        hailuo23Title: 'Hailuo 2.3 AI Video Üretici',
        sora2Title: 'OpenAI Sora-2 AI Video Üretici',

        // FAQ section
        faqTitle: 'Sıkça sorulan sorular',
        faq1Question: 'Seedance 1.0 Pro Fast kimler için uygundur?',
        faq1Answer: 'Özellikle maliyet verimliliği ve üretim verimliliğine odaklanan senaryolarda, sık video üretmesi gereken üreticiler, KOBİ\'ler ve self-media ekipleri için uygundur.',
        
        faq2Question: 'Model nasıl deneyimlenir?',
        faq2Answer: 'Model Volcano Ark platformunda yayına alınmıştır ve kullanıcılar platformun sağladığı deneyim girişinden doğrudan deneyebilir.',
        
        faq3Question: 'Pro Fast, Pro sürümüne göre kaliteyi düşürür mü?',
        faq3Answer: 'Hayır. Hız artarken maliyetler azalırken, Pro Fast talimat takibini ve detay ifadesini optimize eder ve çoğu senaryoda yüksek kaliteyi korur.',
        
        faq4Question: 'Hangi video süresi ve çözünürlük desteklenir?',
        faq4Answer: '2–12 saniye aralığındaki videoları destekler, 720P veya 1080P gibi esnek çözünürlük seçenekleri sunar.',
        
        faq5Question: 'Görüntüden videoya destekler mi? Sonuç nasıl?',
        faq5Answer: 'Evet. Pro Fast, görüntüden videoya üretimde önemli performans gösterir; özellikle detay geri kazanım ve stil tutarlılığında benzer uluslararası modellere göre üstündür.',

        // CTA section
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaDescription: 'Seedance 1.0 Pro Fast’i şimdi deneyin ve profesyonel düzeyde video içeriklerini verimli şekilde oluşturun',
        ctaButton: '微鲤AI’de Seedance 1.0 Pro Fast’i deneyin',
        ctaDisclaimer: 'Kredi kartı gerekmez',

        // Video playback related
        videoNotSupported: 'Tarayıcınız video oynatmayı desteklemiyor',
        videoLoadError: 'Video yüklenemedi',
        videoReload: 'Yeniden yükle',
    },
}
